export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  E164: { input: any; output: any; }
  File: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  OutgoingCallBarringType: { input: any; output: any; }
  /** Time (isoformat) */
  Time: { input: any; output: any; }
  /**
   * Graphene input type for uploading files.
   *
   * This type is used when a pydantic model that contains a starlette.datastructures.UploadFile is passed to
   * create_class_property_dict.
   *
   * When the client sends a query with multipart request the input args will be replaced the GraphQLApp with the
   * UploadFile. (So in the end, this scalar is completely internal.)
   */
  Upload: { input: any; output: any; }
};

export type ActivationTime = {
  /** ID of the activation time */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The list of activation times for a day */
  times: Array<InputMaybe<Scalars['Time']['input']>>;
  /** A day of the week */
  weekdays: Array<InputMaybe<Weekday>>;
};

export type AdditionalFaxSendingEmail = {
  displayName: Scalars['String']['input'];
  enableBodyProcess: Scalars['Boolean']['input'];
  enableProgressFeedback: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  notificationEmail: Scalars['String']['input'];
  shortNumber: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type AdditionalFaxSendingEmails = {
  emails: Array<InputMaybe<AdditionalFaxSendingEmail>>;
};

export type AddressBookEntry = {
  __typename?: 'AddressBookEntry';
  businessCategory?: Maybe<Scalars['String']['output']>;
  capabilities?: Maybe<Array<Capability>>;
  cn: Scalars['String']['output'];
  departmentNumber?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** the unique identifier in LDAP of the entry */
  entryUUID: Scalars['String']['output'];
  givenName?: Maybe<Scalars['String']['output']>;
  /** home number */
  homePhone?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** company name */
  o?: Maybe<Scalars['String']['output']>;
  sn: Scalars['String']['output'];
  telephoneNumber: Array<Scalars['String']['output']>;
  /** extension short number if the extension is from the same domain */
  uid?: Maybe<Scalars['String']['output']>;
};

export type AddressBookEntryData = {
  businessCategory?: InputMaybe<Scalars['String']['input']>;
  departmentNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  /** home number */
  homePhone?: InputMaybe<Scalars['String']['input']>;
  mail?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** company name */
  o?: InputMaybe<Scalars['String']['input']>;
  sn: Scalars['String']['input'];
  telephoneNumber?: Array<Scalars['String']['input']>;
  /** short number if the extension, group or ivr is from the same domain */
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type AddressBookListResult = {
  __typename?: 'AddressBookListResult';
  errors?: Maybe<Array<Error>>;
  rows?: Maybe<Array<AddressBookEntry>>;
  /** The time at which the request was made. This value can be used in a subsequent query to get the changes since this time. */
  timeAtRequest?: Maybe<Scalars['String']['output']>;
};

export type Admin = {
  __typename?: 'Admin';
  aliases: Array<Scalars['String']['output']>;
  canCreateEndpoints: Scalars['Boolean']['output'];
  domainId: Scalars['Int']['output'];
  emails: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sub: Scalars['String']['output'];
};

export enum AgentState {
  AfterCallWork = 'AFTER_CALL_WORK',
  Available = 'AVAILABLE',
  Busy = 'BUSY',
  CcAux1 = 'CC_AUX1',
  CcAux2 = 'CC_AUX2',
  CcAux3 = 'CC_AUX3',
  Meal = 'MEAL',
  Meeting = 'MEETING',
  NotAvailable = 'NOT_AVAILABLE',
  OnThePhone = 'ON_THE_PHONE'
}

export type AllocationInput = {
  /** Name of the item */
  name: Scalars['String']['input'];
  /** Value of the item to be allocated */
  value: Scalars['Int']['input'];
};

export type AssignableUser = {
  __typename?: 'AssignableUser';
  e164?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  shortNumber: Scalars['String']['output'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  actor: Scalars['String']['output'];
  category: AuditLogCategory;
  change: Scalars['String']['output'];
  details: Scalars['JSONString']['output'];
  domain?: Maybe<Domain>;
  domainId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Float']['output'];
  number?: Maybe<Number>;
  numberId?: Maybe<Scalars['Int']['output']>;
  relatedNumber?: Maybe<Number>;
  relatedNumberId?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export enum AuditLogCategory {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type AuditLogList = {
  __typename?: 'AuditLogList';
  items: Array<AuditLog>;
  totalCount: Scalars['Int']['output'];
};

export enum AuditLogsSortBy {
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC'
}

export type BasePhoneButton = {
  __typename?: 'BasePhoneButton';
  buttonPosition: Scalars['Int']['output'];
  buttonType: PhoneButtonType;
  device?: Maybe<Device>;
  deviceId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  linkedDevice?: Maybe<Device>;
  linkedDeviceId?: Maybe<Scalars['Int']['output']>;
  speedDialNumber?: Maybe<Scalars['String']['output']>;
  targetNumber?: Maybe<Number>;
  targetNumberId?: Maybe<Scalars['Int']['output']>;
};

export type BaseUser = {
  __typename?: 'BaseUser';
  alias?: Maybe<Scalars['String']['output']>;
  alternateCallerNumberId?: Maybe<Scalars['Int']['output']>;
  callLimit: Scalars['Int']['output'];
  callPark: Scalars['Boolean']['output'];
  callWaiting: Scalars['Boolean']['output'];
  cliro: Scalars['Boolean']['output'];
  connectedNumberPresentationRestrictionOverride: Scalars['Boolean']['output'];
  directInwardDialing: Scalars['Boolean']['output'];
  directOutwardDialing: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  featuresRestrictions: Array<Maybe<FeatureRestriction>>;
  homeNumber: Scalars['String']['output'];
  hotnumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internationalCac: Scalars['String']['output'];
  lastCallId?: Maybe<Scalars['String']['output']>;
  lastCallReturn?: Maybe<Scalars['String']['output']>;
  ldapPassword?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['Int']['output'];
  maliciousCallTrace: Scalars['Boolean']['output'];
  mobileNumber: Scalars['String']['output'];
  monthlyLimit?: Maybe<Scalars['Float']['output']>;
  nationalCac: Scalars['String']['output'];
  needWebPasswordChange: Scalars['Boolean']['output'];
  notificationEmail?: Maybe<Scalars['String']['output']>;
  numberId: Scalars['Int']['output'];
  outgoingCallBarringAdmin?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringOperator?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringUser?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  pin: Scalars['String']['output'];
  previewFeaturesEnabled: Scalars['Boolean']['output'];
  privateRoutingType: PrivateRoutingType;
  recordingFileSize: Scalars['Int']['output'];
  recordingType: DirectionType;
  redirectToSecretary: Scalars['Boolean']['output'];
  secretaryNumberId?: Maybe<Scalars['Int']['output']>;
  sendAccounting?: Maybe<Scalars['Boolean']['output']>;
  speeddial8: Scalars['Boolean']['output'];
  speeddial100: Scalars['Boolean']['output'];
  useOcs?: Maybe<Scalars['Boolean']['output']>;
  userPackageName?: Maybe<Scalars['String']['output']>;
  userSub?: Maybe<Scalars['String']['output']>;
  voicemailToEmailEnabled: Scalars['Boolean']['output'];
  xcapPassword: Scalars['String']['output'];
};

export type BulkAddressBookModificationResult = {
  __typename?: 'BulkAddressBookModificationResult';
  /** Number of entries that were added to the address book. */
  added: Scalars['Int']['output'];
  /** Number of entries that were deleted from the address book. */
  deleted: Scalars['Int']['output'];
  errors?: Maybe<Array<Error>>;
  /** Progress of the operation in the range of 0 to 1. */
  progress: Scalars['Float']['output'];
  /** Number of entries that were updated in the address book. */
  updated: Scalars['Int']['output'];
};

export type BulkCapabilityModificationInfo = {
  __typename?: 'BulkCapabilityModificationInfo';
  allocated: Scalars['Int']['output'];
  allowGrant: Scalars['Boolean']['output'];
  capability: Scalars['String']['output'];
  used: Scalars['Int']['output'];
};

export type BulkUserDeviceInfo = {
  __typename?: 'BulkUserDeviceInfo';
  /** The MAC address of the provisioned device */
  macAddress: Scalars['String']['output'];
  /** The vendor of the provisioned device */
  vendor: Scalars['String']['output'];
};

export type BulkUserInfo = {
  __typename?: 'BulkUserInfo';
  /** The display name of the user */
  displayName: Scalars['String']['output'];
  /** The E.164 number of the user (#auto_ is not included) */
  e164?: Maybe<Scalars['String']['output']>;
  /** The home number of the user */
  homeNumber?: Maybe<Scalars['String']['output']>;
  /** The location of the user */
  location: Scalars['String']['output'];
  /** The email address of the user of this user. Returned if the user has only one login. */
  loginEmail?: Maybe<Scalars['String']['output']>;
  /** The mobile number of the user */
  mobileNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the user has multiple logins. */
  multipleLogins: Scalars['Boolean']['output'];
  /** The provisioned device information of the user */
  provisionedDevice?: Maybe<BulkUserDeviceInfo>;
  /** The short number of the user */
  shortNumber: Scalars['String']['output'];
  /** The user package name of the user */
  userPackageName?: Maybe<Scalars['String']['output']>;
};

export type BulkUserModificationData = {
  /** Display name of the user */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** E.164 number of the user */
  e164?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the user that will be added to the user if it is allowed */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Home number of the user */
  homeNumber?: InputMaybe<Scalars['String']['input']>;
  /** Language to apply to the users if a login is added */
  language?: Scalars['String']['input'];
  /** The location name of the user */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Mobile number of the user */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /** The provisioned device of the user. If multiple devices belongs to the user, this field represents the first device by the time of creation. */
  provisionedDevice?: InputMaybe<BulkUserProvisionedDevice>;
  /** Short number of the user */
  shortNumber?: InputMaybe<Scalars['String']['input']>;
  /** The user package name of the user. If not provided, and domain has default user package, that will be used. */
  userPackageName?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUserModificationError = {
  __typename?: 'BulkUserModificationError';
  /** The column number where the error occurred */
  column?: Maybe<Scalars['Int']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  /** The row number where the error occurred */
  row: Scalars['Int']['output'];
  /** The sheet number where the error occurred */
  sheet: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type BulkUserModificationResult = {
  __typename?: 'BulkUserModificationResult';
  /** List of errors that occurred during processing the excel sheets */
  errors?: Maybe<Array<BulkUserModificationError>>;
  /** Result summary for locations */
  locations: BulkUserModificationResultLocations;
  /** Result summary for users */
  users: BulkUserModificationResultUsers;
};

export type BulkUserModificationResultLocations = {
  __typename?: 'BulkUserModificationResultLocations';
  /** Number of created locations */
  created: Scalars['Int']['output'];
  /** Number of updated locations */
  updated: Scalars['Int']['output'];
};

export type BulkUserModificationResultUsers = {
  __typename?: 'BulkUserModificationResultUsers';
  /** Number of created users */
  created: Scalars['Int']['output'];
  /** Number of updated users */
  updated: Scalars['Int']['output'];
};

export type BulkUserProvisionedDevice = {
  /** The MAC address of the provisioned device. Required if creating a new device. */
  macAddress?: InputMaybe<Scalars['String']['input']>;
  /** The vendor of the provisioned device. Required if creating a new device. */
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type Call = {
  __typename?: 'Call';
  callId: Scalars['String']['output'];
  /** the time when the call initiated or in case of successful calls when it connected */
  callTime: Scalars['DateTime']['output'];
  /** the E.164 of the remote party except for in-domain calls when it is the dialed number */
  cdrNumber: Scalars['String']['output'];
  conferenceMembers?: Maybe<Array<ConferenceMember>>;
  /** the time the call connected (if connected) */
  connectTime: Scalars['DateTime']['output'];
  /** if the call connected for audio or video exchange */
  connected: Scalars['Boolean']['output'];
  /** connected number */
  connectedNumber?: Maybe<Scalars['String']['output']>;
  /**
   *
   * direction and remote party category merged into one enum
   * s - service
   * m - private-gateway
   * x - external-pbx
   * d - in-domain
   * o - external
   * i - any incoming
   * c - conference
   *
   */
  direction: Scalars['String']['output'];
  /** the reason why the call was disconnected */
  disconnectReason?: Maybe<DisconnectReason>;
  /** the time the call disconnected (if connected) */
  disconnectTime: Scalars['DateTime']['output'];
  /** duration in seconds */
  duration: Scalars['Int']['output'];
  /** own e164 */
  e164: Scalars['String']['output'];
  /** the domain part of the local party */
  localDomain: Scalars['String']['output'];
  /** alias for e164 */
  localE164: Scalars['String']['output'];
  /** alias for short_number */
  localNumber: Scalars['String']['output'];
  /** The DB ID of the local number */
  localNumberId?: Maybe<Scalars['Int']['output']>;
  /** for outgoing calls this is the dialed number, for incoming calls this is the provided caller number; can be 'anonymous' if hidden */
  number: Scalars['String']['output'];
  /** The number of the endpoint on which behalf the call was started */
  onBehalfOf?: Maybe<Scalars['String']['output']>;
  /** only set in case of call forward */
  originalCallingE164?: Maybe<Scalars['String']['output']>;
  /** only set in case of call forward */
  originalCallingNumber?: Maybe<Scalars['String']['output']>;
  /** if this is a private call - user indicated that it is not for work */
  private: Scalars['Boolean']['output'];
  /** the UUID of the recording if the call media was recorded */
  recordingId?: Maybe<Scalars['String']['output']>;
  /** Where the recording is stored. None if there is no recording. */
  recordingStore?: Maybe<RecordingStore>;
  /** contains a valid E.164 associated with the remote party - it can possibly be a pilot number useful for billing; can be 'anonymous' if hidden */
  remoteE164: Scalars['String']['output'];
  /** Remote party name (if set) */
  remoteName?: Maybe<Scalars['String']['output']>;
  /** alias for number */
  remoteNumber: Scalars['String']['output'];
  /** The DB ID of the remote number (if call is is internal) */
  remoteNumberId?: Maybe<Scalars['Int']['output']>;
  /** when a call is segmented in time, then this shows the purpose of the segment */
  segmentType: SegmentType;
  /** session type */
  sessionType: SessionType;
  /** own short number */
  shortNumber: Scalars['String']['output'];
  /** for transfer or reroute segments this holds the number of the third party */
  thirdPartyNumber?: Maybe<Scalars['String']['output']>;
};

export enum CallControlCommandError {
  CallControlError = 'CALL_CONTROL_ERROR',
  IncompleteData = 'INCOMPLETE_DATA',
  UnknownDevice = 'UNKNOWN_DEVICE'
}

export type CallForwardNoAnswer = {
  enabled?: Scalars['Boolean']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  timeout?: Scalars['Int']['input'];
};

export type CallGroupRetarget = {
  /** The number ID of the new target. */
  newTargetNumberId: Scalars['Int']['input'];
  /** The ID of the referrer. */
  referrerId: Scalars['Int']['input'];
};

export type CallGroupRetargets = {
  /** New reference targets for gateways. */
  gateways: Array<InputMaybe<CallGroupRetarget>>;
  /** New reference targets for auto attendants. */
  ivrs: Array<InputMaybe<CallGroupRetarget>>;
  /** New reference targets for users. */
  users: Array<InputMaybe<CallGroupRetarget>>;
};

export enum CallGroupType {
  CallQueue = 'CALL_QUEUE',
  Parallel = 'PARALLEL',
  Serial = 'SERIAL'
}

export type CallList = {
  __typename?: 'CallList';
  calls: Array<Call>;
  cursor?: Maybe<Scalars['Int']['output']>;
  hasNext: Scalars['Boolean']['output'];
};

export type CallListInterval = {
  /** interval length in seconds */
  length: Scalars['Int']['input'];
  /** start */
  start: Scalars['DateTime']['input'];
};

export type CallQueue = {
  __typename?: 'CallQueue';
  /** After call work length in seconds. */
  acwLength?: Maybe<Scalars['Int']['output']>;
  /** Whether the call queue has address book */
  hasAddressBook?: Maybe<Scalars['Boolean']['output']>;
  /** The algorithm to select agents. */
  huntingAlgorithmType?: Maybe<HuntingAlgorithmType>;
  /** Identifier of the group. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of calls that can wait in a queue. */
  maxQueueLength?: Maybe<Scalars['Int']['output']>;
  /** Calls waiting more than this time will be disconnected after a voice message. */
  maxWaitingTime?: Maybe<Scalars['Int']['output']>;
  /** Media files for the call queue. */
  media?: Maybe<CallQueueMediaFiles>;
  /** Name of the group. */
  name?: Maybe<Scalars['String']['output']>;
  /** Number id related to the group. */
  numberId?: Maybe<Scalars['Int']['output']>;
  /** Outgoing call barring setting for calls started with the group number. This setting can be modified by the admin. */
  outgoingCallBarringAdmin?: Maybe<Array<Maybe<OutgoingCallBarring>>>;
  /** Outgoing call barring setting for calls started with the group number. This setting can be modified by the operator. */
  outgoingCallBarringOperator?: Maybe<Array<Maybe<OutgoingCallBarring>>>;
  /** DEPRECATED */
  overflowNumberId?: Maybe<Scalars['Int']['output']>;
  /** Priority of the call queue. */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Ringing timeout when sequential search is used. */
  sequentialTimeout?: Maybe<Scalars['Int']['output']>;
};

export type CallQueueMedia = {
  /** Description of the media. If not provided, file name will be used as description instead. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** File to upload. */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** ID of the already existing domain media to be set. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to delete the currently set file. */
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CallQueueMediaFiles = {
  __typename?: 'CallQueueMediaFiles';
  /** Message played when the queue is full. */
  queueFull?: Maybe<MediaFileInfo>;
  /** Message played when the queue times out. */
  queueTimeout?: Maybe<MediaFileInfo>;
  /** Message played when waiting in the queue. */
  waiting?: Maybe<MediaFileInfo>;
};

export enum CallbackType {
  AcceptReceivedCalledNumber = 'ACCEPT_RECEIVED_CALLED_NUMBER',
  AlwaysCallbackNumber = 'ALWAYS_CALLBACK_NUMBER',
  MatchAccordingOrFallBack = 'MATCH_ACCORDING_OR_FALL_BACK',
  PreviousOptionsWithDisa = 'PREVIOUS_OPTIONS_WITH_DISA'
}

export enum Capability {
  AttendantConsole = 'ATTENDANT_CONSOLE',
  AudioCall = 'AUDIO_CALL',
  CcAgent = 'CC_AGENT',
  CcSupervisor = 'CC_SUPERVISOR',
  Chat = 'CHAT',
  ChatGroups = 'CHAT_GROUPS',
  DesktopPhoneControl = 'DESKTOP_PHONE_CONTROL',
  DesktopSharing = 'DESKTOP_SHARING',
  MediaEncryption = 'MEDIA_ENCRYPTION',
  Presence = 'PRESENCE',
  VideoCall = 'VIDEO_CALL',
  Voicemail = 'VOICEMAIL'
}

export type CapabilityLimit = {
  __typename?: 'CapabilityLimit';
  chat: LimitInfo;
  userId: Scalars['Int']['output'];
};

export type CapabilityModification = {
  /** Name of the capability to be modified */
  name: Scalars['String']['input'];
  /** Type of modification to be performed */
  type: CapabilityModificationType;
};

export enum CapabilityModificationType {
  Grant = 'GRANT',
  Keep = 'KEEP',
  Revoke = 'REVOKE'
}

/** Capability set and its capabilities from the limit file */
export type CapabilitySet = {
  __typename?: 'CapabilitySet';
  /** List of capabilities in the capability set */
  capabilities: Array<Scalars['String']['output']>;
  /** Name of the capability set */
  name: Scalars['String']['output'];
};

export type Client = {
  __typename?: 'Client';
  allowChatToEveryNumber: Scalars['Boolean']['output'];
  fallbackToGsm: Array<Scalars['String']['output']>;
  sendReport: SendReport;
  settings: Array<ClientSetting>;
};

export type ClientDevice = {
  __typename?: 'ClientDevice';
  clientInfo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gruu?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  registrationExpireTime?: Maybe<Scalars['DateTime']['output']>;
  registrationTime?: Maybe<Scalars['DateTime']['output']>;
  sipPassword: Scalars['String']['output'];
  sipUser: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ClientSetting = {
  __typename?: 'ClientSetting';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ClientType {
  All = 'ALL',
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type ConferenceMember = {
  __typename?: 'ConferenceMember';
  /** connect_time */
  connectTime: Scalars['DateTime']['output'];
  /** disconnect_time */
  disconnectTime: Scalars['DateTime']['output'];
  /** e164 */
  e164: Scalars['String']['output'];
  /** Display name (if set) */
  name?: Maybe<Scalars['String']['output']>;
  /** number */
  number: Scalars['String']['output'];
};

export type Context = {
  __typename?: 'Context';
  /** Data associated with the context. */
  data: Scalars['JSON']['output'];
  /** ID of the context. */
  id: Scalars['Int']['output'];
  /** Name of the context. */
  name: Scalars['String']['output'];
};

export enum ControllingLineState {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type CreateCallGroupMember = {
  /** Whether this member is supervisor of the group. Can only be set if the call group is a call queue. */
  controllingLine?: Scalars['Boolean']['input'];
  /** Number ID of the member to add to the call group */
  numberId: Scalars['Int']['input'];
};

export type CreateUserData = {
  alias?: InputMaybe<Scalars['String']['input']>;
  alternateCallerNumberId?: InputMaybe<Scalars['Int']['input']>;
  callLimit?: Scalars['Int']['input'];
  callOriginationDenied?: Scalars['Boolean']['input'];
  callTerminationDenied?: Scalars['Boolean']['input'];
  callWaiting?: Scalars['Boolean']['input'];
  capabilitySets?: Array<Scalars['String']['input']>;
  cliro?: Scalars['Boolean']['input'];
  connectedNumberPresentationRestrictionOverride?: Scalars['Boolean']['input'];
  deviceTypeSets?: Array<DeviceTypeSetLimit>;
  directInwardDialing?: InputMaybe<Scalars['Boolean']['input']>;
  directOutwardDialing?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  e164?: InputMaybe<Scalars['String']['input']>;
  featureRestrictions?: Array<FeatureRestriction>;
  homeNumber?: InputMaybe<Scalars['String']['input']>;
  hotNumber?: InputMaybe<Scalars['String']['input']>;
  internationalCac?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  login?: InputMaybe<CreateUserLoginData>;
  maliciousCallTrace?: Scalars['Boolean']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  nationalCac?: InputMaybe<Scalars['String']['input']>;
  nonPaymentBlockingType?: InputMaybe<NonPaymentBlockingType>;
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  outgoingCallBarringAdmin?: InputMaybe<Array<OutgoingCallBarring>>;
  outgoingCallBarringOperator?: InputMaybe<Array<OutgoingCallBarring>>;
  outgoingCallBarringUser?: InputMaybe<Array<OutgoingCallBarring>>;
  pin: Scalars['String']['input'];
  previewFeaturesEnabled?: Scalars['Boolean']['input'];
  privateRoutingType?: InputMaybe<PrivateRoutingType>;
  profiles: Array<CreateUserProfileData>;
  secretaryNumberId?: InputMaybe<Scalars['Int']['input']>;
  shortNumber?: InputMaybe<Scalars['String']['input']>;
  speedDials?: Array<CreateUserSpeedDial>;
  userPackageName?: InputMaybe<Scalars['String']['input']>;
  voicemailToEmailEnabled?: Scalars['Boolean']['input'];
};

export type CreateUserLoginData = {
  /** Must set if no hashed password is provided */
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  passwordHash?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserLoginInput = {
  email: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  withAliases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserProfileActivationSettings = {
  /** Activation values for the profile */
  activationTimes?: Array<CreateUserProfileActivationTime>;
  /** List of specific activation times for the profile */
  specialDays?: Array<CreateUserProfileSpecialDay>;
};

export type CreateUserProfileActivationTime = {
  /** The list of activation times for a day */
  times: Array<Scalars['Time']['input']>;
  /** A day of the week */
  weekdays: Array<Weekday>;
};

export type CreateUserProfileData = {
  active: Scalars['Boolean']['input'];
  anonymousCallRejection?: Scalars['Boolean']['input'];
  callForwardBusy?: InputMaybe<E164Toggle>;
  callForwardFault?: InputMaybe<E164Toggle>;
  callForwardNoanswer?: InputMaybe<CallForwardNoAnswer>;
  callForwardUnavailable?: InputMaybe<E164Toggle>;
  callForwardUnconditional?: InputMaybe<E164Toggle>;
  callingNamePresentation?: Scalars['Boolean']['input'];
  callingNumberPresentationRestriction?: Scalars['Boolean']['input'];
  connectedNumberPresentationRestriction?: Scalars['Boolean']['input'];
  doNotDisturb?: Scalars['Boolean']['input'];
  locked?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  parallelRinging?: InputMaybe<E164Toggle>;
  rejectDivertedCalls?: Scalars['Boolean']['input'];
  rules?: Array<CreateUserProfileRule>;
  secretaryMode?: SecretaryMode;
  /** Activation times settings */
  settings?: InputMaybe<CreateUserProfileActivationSettings>;
  stickyProfile?: Scalars['Boolean']['input'];
};

export type CreateUserProfileRule = {
  action: ExtensionProfileRuleAction;
  matchType?: InputMaybe<UserProfileRuleMatchType>;
  priority: Scalars['Int']['input'];
  sourceNumber: Scalars['String']['input'];
  targetNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserProfileSpecialDay = {
  /** Time of the activation for the special day */
  activationTime?: InputMaybe<Scalars['Time']['input']>;
  /** Date of the activation for the special day */
  day: Scalars['Date']['input'];
  /** Use this activation time in every year or not */
  everyYear: Scalars['Boolean']['input'];
};

export type CreateUserSpeedDial = {
  description: Scalars['String']['input'];
  shortNumber: Scalars['String']['input'];
  targetNumber: Scalars['String']['input'];
};

/**
 * Describes default device limits.
 *
 * When the limit is 0, the default cannot be different from 0.
 */
export type DefaultDevice = {
  __typename?: 'DefaultDevice';
  /** The limit in the limit file of for the device type set. */
  limit: Scalars['Int']['output'];
  /** The name of the device type set for which this default applies. */
  name: Scalars['String']['output'];
  /** The default value for the device type set. */
  value: Scalars['Int']['output'];
};

export type DefaultDeviceVariant = {
  __typename?: 'DefaultDeviceVariant';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DefaultVendor = {
  __typename?: 'DefaultVendor';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DeleteDomainStatus = {
  __typename?: 'DeleteDomainStatus';
  /** List of errors that occurred during the operation. If any error happened, the deletion of the domain may not have been completed, but some part of it may. Thus, the domain might remain in a corrupted state. */
  errors?: Maybe<Array<Error>>;
  /** Progress of the operation in the range of 0 to 1. */
  progress: Scalars['Float']['output'];
};

export type Destination = {
  __typename?: 'Destination';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberingPlans: Array<NumberingPlan>;
};

export type DestinationList = {
  __typename?: 'DestinationList';
  items: Array<Maybe<Destination>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DestinationModel = {
  /** ID of the destination. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the destination. */
  name: Scalars['String']['input'];
  /** List of numbering plans belongs to this destination. */
  numberingPlans: Array<InputMaybe<DestinationPlan>>;
};

export type DestinationPlan = {
  /** ID of the numbering plan. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Prefix of the numbering plan. */
  prefix: Scalars['String']['input'];
};

/** Base device - only meant to allow relationships to the devices table. */
export type Device = {
  __typename?: 'Device';
  buttons: Array<BasePhoneButton>;
  clientInfo?: Maybe<Scalars['String']['output']>;
  contactAddress?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<User>;
  extensionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  registrationExpireTime?: Maybe<Scalars['DateTime']['output']>;
  registrationTime?: Maybe<Scalars['DateTime']['output']>;
  sipPassword: Scalars['String']['output'];
  sipUser: Scalars['String']['output'];
};

export type DeviceResynchronizeResult = {
  __typename?: 'DeviceResynchronizeResult';
  devices: Array<DeviceResynchronizeStatus>;
  error?: Maybe<ResynchronizeError>;
};

export type DeviceResynchronizeStatus = {
  __typename?: 'DeviceResynchronizeStatus';
  error?: Maybe<CallControlCommandError>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DeviceSetLimit = {
  __typename?: 'DeviceSetLimit';
  /** List of device types the limit applies to. */
  devices: Array<Scalars['String']['output']>;
  /** The quota limit for the specified device types. None if unlimited. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Name of the device type set that defines the limit. */
  setName: Scalars['String']['output'];
};

export enum DeviceType {
  Client = 'CLIENT',
  Linked = 'LINKED',
  Provisioned = 'PROVISIONED',
  Thirdparty = 'THIRDPARTY'
}

export type DeviceTypeSet = {
  __typename?: 'DeviceTypeSet';
  /** List of devices in the device type set */
  devices: Array<Scalars['String']['output']>;
  /** Name of the device type set */
  name: Scalars['String']['output'];
};

export type DeviceTypeSetLimit = {
  name: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type DeviceVariant = {
  __typename?: 'DeviceVariant';
  domain?: Maybe<Domain>;
  domainId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DeviceVariantList = {
  __typename?: 'DeviceVariantList';
  items: Array<Maybe<DeviceVariant>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum DirectionType {
  Both = 'BOTH',
  In = 'IN',
  None = 'NONE',
  Out = 'OUT'
}

/** the reason this call was disconnected */
export enum DisconnectReason {
  Busy = 'BUSY',
  CallerDisconnect = 'CALLER_DISCONNECT',
  None = 'NONE',
  Other = 'OTHER',
  Transferred = 'TRANSFERRED'
}

export type Document = {
  __typename?: 'Document';
  audience?: Maybe<DocumentAudience>;
  description?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum DocumentAudience {
  Admin = 'ADMIN',
  Operator = 'OPERATOR',
  User = 'USER'
}

export type Domain = {
  __typename?: 'Domain';
  accountingCommunity?: Maybe<Scalars['String']['output']>;
  adminCreateDeleteEndpointsEnabled: Scalars['Boolean']['output'];
  attendantPrefix?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundIsCenter?: Maybe<Scalars['Boolean']['output']>;
  baseColor?: Maybe<Scalars['String']['output']>;
  billingId: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  defaultCapabilitySetForExtensions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  defaultClientCapabilities: Scalars['Int']['output'];
  defaultDeviceLimits?: Maybe<Scalars['JSONString']['output']>;
  defaultDeviceVariantId?: Maybe<Scalars['Int']['output']>;
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  defaultUserPackage?: Maybe<Scalars['String']['output']>;
  defaultVendorId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  dialoutPrefix?: Maybe<Scalars['String']['output']>;
  domainType: DomainType;
  endpointE164RangesForAdmins?: Maybe<Scalars['String']['output']>;
  faxSignature?: Maybe<Scalars['String']['output']>;
  groupDomain?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  images: Array<DomainImage>;
  incomingAndOutgoingBlocked?: Maybe<Scalars['Int']['output']>;
  ldapPassword: Scalars['String']['output'];
  loginBackgroundColor?: Maybe<Scalars['String']['output']>;
  mohSound?: Maybe<Media>;
  mohSoundDownloadToken?: Maybe<Scalars['String']['output']>;
  mohSoundId?: Maybe<Scalars['Int']['output']>;
  monthlyLimit?: Maybe<Scalars['Float']['output']>;
  monthlyLimitExtensionDefault?: Maybe<Scalars['Float']['output']>;
  monthlyLimitServicePlanDefault?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  notBlocked?: Maybe<Scalars['Int']['output']>;
  outgoingBlocked?: Maybe<Scalars['Int']['output']>;
  outgoingCallBarringAdmin?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringOperator?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  parkSound?: Maybe<Media>;
  parkSoundDownloadToken?: Maybe<Scalars['String']['output']>;
  parkSoundId?: Maybe<Scalars['Int']['output']>;
  pinBasedCalls?: Maybe<Scalars['Boolean']['output']>;
  preferDisplayNamesForStationNames: Scalars['Boolean']['output'];
  presenceInDomainPreauthorized: Scalars['Boolean']['output'];
  priceLimitExtensionDefault?: Maybe<Scalars['Float']['output']>;
  privateRoutingType: PrivateRoutingType;
  quotaCallQueue: Scalars['Int']['output'];
  quotaCcBase: Scalars['Boolean']['output'];
  quotaFax: Scalars['Int']['output'];
  quotaGroup5: Scalars['Int']['output'];
  quotaGroup10: Scalars['Int']['output'];
  quotaGroup20: Scalars['Int']['output'];
  quotaIvr: Scalars['Int']['output'];
  recordingLocation?: Maybe<Scalars['String']['output']>;
  recordingRetention?: Maybe<Scalars['Int']['output']>;
  requirePinForStartingPrivateCalls: Scalars['Boolean']['output'];
  sendAccounting?: Maybe<Scalars['Boolean']['output']>;
  shortNumbersLength: Scalars['Int']['output'];
  smtpAuthEnabled?: Maybe<Scalars['Boolean']['output']>;
  smtpUsername?: Maybe<Scalars['String']['output']>;
  smtpUserpass?: Maybe<Scalars['String']['output']>;
  specialNumbersDialoutPrefix?: Maybe<Scalars['String']['output']>;
  startingBalance?: Maybe<Scalars['Float']['output']>;
  statisticsEmail?: Maybe<Scalars['String']['output']>;
  tariffPackageIdDefault?: Maybe<Scalars['Int']['output']>;
  timeLimitExtensionDefault?: Maybe<Scalars['Int']['output']>;
  useOcs?: Maybe<Scalars['Boolean']['output']>;
};

export type DomainAdminInput = {
  aliases: Array<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  passwordHash: Scalars['String']['input'];
};

export type DomainAllocationInfo = {
  __typename?: 'DomainAllocationInfo';
  /** If the remaining value is non-zero, then no error is returned. Otherwise, superusers get an error only if the system limit is reached, and admins get an error when the domain limit is reached. */
  allocationIncrementError?: Maybe<Error>;
  /** Allocated value of this item for the requested domain */
  domainAllocated: Scalars['Int']['output'];
  /** Number of this item being used in the requested domain */
  domainUsed: Scalars['Int']['output'];
  /** Remaining value of this item for the requested domain */
  remaining: Scalars['Int']['output'];
  /** System limit for this item. If null, the quota is unlimited. */
  systemLimit?: Maybe<Scalars['Int']['output']>;
  /** Allocated value of this item across all domains */
  totalAllocated: Scalars['Int']['output'];
};

export type DomainAllocationInfoWithName = {
  __typename?: 'DomainAllocationInfoWithName';
  /** If the remaining value is non-zero, then no error is returned. Otherwise, superusers get an error only if the system limit is reached, and admins get an error when the domain limit is reached. */
  allocationIncrementError?: Maybe<Error>;
  /** Allocated value of this item for the requested domain */
  domainAllocated: Scalars['Int']['output'];
  /** Number of this item being used in the requested domain */
  domainUsed: Scalars['Int']['output'];
  /** Name of the item */
  name: Scalars['String']['output'];
  /** Remaining value of this item for the requested domain */
  remaining: Scalars['Int']['output'];
  /** System limit for this item. If null, the quota is unlimited. */
  systemLimit?: Maybe<Scalars['Int']['output']>;
  /** Allocated value of this item across all domains */
  totalAllocated: Scalars['Int']['output'];
};

export type DomainAllocations = {
  __typename?: 'DomainAllocations';
  capabilitySets: Array<DomainAllocationInfoWithName>;
  deviceTypeSets: Array<DomainAllocationInfoWithName>;
  services: ServiceDomainAllocationsInfo;
  userPackages: Array<DomainAllocationInfoWithName>;
};

export type DomainAudioInput = {
  /** Name of the media */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Media file. Only not none if it is a new upload. */
  file?: InputMaybe<Scalars['File']['input']>;
  fortest?: Scalars['Boolean']['input'];
  /** Id of the media. For audio fields, it can be used to assign existing domain media to the field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Unassign the media from the field */
  unset?: Scalars['Boolean']['input'];
};

export type DomainDefaultsInfo = {
  __typename?: 'DomainDefaultsInfo';
  deviceVariant?: Maybe<DefaultDeviceVariant>;
  language?: Maybe<Scalars['String']['output']>;
  vendor: DefaultVendor;
};

export type DomainImage = {
  __typename?: 'DomainImage';
  date?: Maybe<Scalars['DateTime']['output']>;
  domain?: Maybe<Domain>;
  domainId: Scalars['Int']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mime?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type DomainImageInput = {
  /** Name of the media */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Media file. Only not none if it is a new upload. */
  file?: InputMaybe<Scalars['File']['input']>;
  fortest?: Scalars['Boolean']['input'];
  /** Id of the media. For audio fields, it can be used to assign existing domain media to the field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Unassign the media from the field */
  unset?: Scalars['Boolean']['input'];
};

export type DomainList = {
  __typename?: 'DomainList';
  items: Array<Maybe<Domain>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Quota defaults for the domain. */
export type DomainQuotaDefaultsInfo = {
  __typename?: 'DomainQuotaDefaultsInfo';
  /** The list of available capability sets in the limit file. */
  availableCapabilities: Array<Scalars['String']['output']>;
  /** The list of available user packages in the limit file */
  availableUserPackages: Array<Scalars['String']['output']>;
  /** The default settings for user capability sets */
  defaultCapabilities?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The default settings for the device type set quotas. Even if there are no defaults, this will
   * return all device device type sets with a default value of 0
   */
  defaultDevices: Array<DefaultDevice>;
  /** The default user package for the domain */
  defaultUserPackage?: Maybe<Scalars['String']['output']>;
};

export type DomainSettingsBackgroundInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<DomainImageInput>;
  isCentered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DomainSettingsInput = {
  /** Attendant prefix */
  attendantPrefix?: InputMaybe<Scalars['String']['input']>;
  /** Background settings */
  background?: InputMaybe<DomainSettingsBackgroundInput>;
  /** Primary color of the concerto web */
  baseColor?: InputMaybe<Scalars['String']['input']>;
  /** Company name of the domain */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Description of the domain */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Dialout prefix */
  dialoutPrefix?: InputMaybe<Scalars['String']['input']>;
  /** Fax signature */
  faxSignature?: InputMaybe<Scalars['String']['input']>;
  /** Group domain */
  groupDomain?: InputMaybe<Scalars['String']['input']>;
  /** ID of the domain to update. */
  id: Scalars['Int']['input'];
  /** Login page settings */
  login?: InputMaybe<DomainSettingsLoginInput>;
  /** Image file for logo */
  logo?: InputMaybe<DomainImageInput>;
  /** Outgoing call barring settings */
  outgoingCallBarring?: InputMaybe<DomainSettingsOutgoingCallBarringInput>;
  /** Pin based calls */
  pinBasedCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Prefer display names for station names */
  preferDisplayNamesForStationNames?: InputMaybe<Scalars['Boolean']['input']>;
  /** User presence information is available inside the domain without authorization. */
  presenceInDomainPreauthorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Private routing type */
  privateRoutingType?: InputMaybe<PrivateRoutingType>;
  /** Recording settings */
  recording?: InputMaybe<DomainSettingsRecordingInput>;
  /** Require pin for starting private calls */
  requirePinForStartingPrivateCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** SMTP authentication settings */
  smtp?: InputMaybe<DomainSettingsSmtpInput>;
  /** Sound settings */
  sounds?: InputMaybe<DomainSettingsSoundsInput>;
  /** Special numbers dialout prefix */
  specialNumbersDialoutPrefix?: InputMaybe<Scalars['String']['input']>;
};

export type DomainSettingsLoginInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  logoImage?: InputMaybe<DomainImageInput>;
};

export type DomainSettingsOutgoingCallBarringInput = {
  admin?: InputMaybe<Array<OutgoingCallBarring>>;
  operator?: InputMaybe<Array<OutgoingCallBarring>>;
};

export type DomainSettingsRecordingInput = {
  /** If set, recording is not stored internally but sent to the specified location. Allowed locations: mailto:<email address> or sftp:<user>@<host>:<path> */
  location?: InputMaybe<Scalars['String']['input']>;
  /** The time a recording will be kept for. Null means using system default. */
  retention?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainSettingsSmtpInput = {
  /** SMTP authentication is enabled or not */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Username for SMTP authentication, can only be changed if SMTP authentication is enabled */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Password for SMTP authentication, can only be changed if SMTP authentication is enabled */
  userpass?: InputMaybe<Scalars['String']['input']>;
};

export type DomainSettingsSoundsInput = {
  moh?: InputMaybe<DomainAudioInput>;
  park?: InputMaybe<DomainAudioInput>;
};

export type DomainStatus = {
  __typename?: 'DomainStatus';
  gateways: Array<GatewayStatus>;
  locations: Array<LocationStatus>;
};

export type DomainSummary = {
  __typename?: 'DomainSummary';
  callGroups: Scalars['Int']['output'];
  callQueues: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  faxes: Scalars['Int']['output'];
  gateways: Scalars['Int']['output'];
  ivrs: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pickupGroups: Scalars['Int']['output'];
  shortNumbersLength: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type DomainTheme = {
  __typename?: 'DomainTheme';
  background?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundIsCentered?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
};

export enum DomainType {
  Business = 'BUSINESS',
  Residential = 'RESIDENTIAL'
}

export type E164Range = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type E164Toggle = {
  enabled?: Scalars['Boolean']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
};

/** Describes a validation error. */
export type Error = {
  __typename?: 'Error';
  /** JSON encoded context of the error, that can be used to parametrize the translation. */
  context?: Maybe<Scalars['String']['output']>;
  /** Location of the error in the input data. */
  location: Array<Scalars['String']['output']>;
  /** Description of the issue in English */
  msg?: Maybe<Scalars['String']['output']>;
  /** Type of the error that can be used as the translation key. */
  type: Scalars['String']['output'];
};

export type ExtensionProfileDnd = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export enum ExtensionProfileRuleAction {
  Answer = 'ANSWER',
  AnswerImmediately = 'ANSWER_IMMEDIATELY',
  DistinctiveRinging = 'DISTINCTIVE_RINGING',
  Forward = 'FORWARD',
  Reject = 'REJECT'
}

export type Fax = {
  __typename?: 'Fax';
  headerInfo: Scalars['String']['output'];
  headerNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  incomingEmailAddress?: Maybe<Scalars['String']['output']>;
  notifyUnsuccessfulReceiving: Scalars['Boolean']['output'];
  number?: Maybe<Number>;
  numberId: Scalars['Int']['output'];
  outgoingCallBarringAdmin?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringOperator?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  password: Scalars['String']['output'];
  senderEmailAddress?: Maybe<Scalars['String']['output']>;
};

export enum FaxDirection {
  All = 'ALL',
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING'
}

export type FaxList = {
  __typename?: 'FaxList';
  items: Array<Maybe<Fax>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FaxRecord = {
  __typename?: 'FaxRecord';
  direction: FaxDirection;
  pages: Scalars['Int']['output'];
  remote: Scalars['String']['output'];
  status: FaxStatus;
  subject: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
};

export type FaxRecords = {
  __typename?: 'FaxRecords';
  records: Array<FaxRecord>;
};

export type FaxRecordsInterval = {
  /** interval length in seconds */
  length: Scalars['Int']['input'];
  /** start */
  start: Scalars['Date']['input'];
};

export type FaxRetarget = {
  /** The number ID of the new target. */
  newTargetNumberId: Scalars['Int']['input'];
  /** The ID of the referrer. */
  referrerId: Scalars['Int']['input'];
};

export type FaxRetargets = {
  /** New reference targets for auto attendants. */
  ivrs: Array<InputMaybe<FaxRetarget>>;
  /** New reference targets for users. */
  users: Array<InputMaybe<FaxRetarget>>;
};

export enum FaxStatus {
  Error = 'ERROR',
  Sent = 'SENT',
  UnderProcessing = 'UNDER_PROCESSING'
}

export type FaxesEmail = {
  __typename?: 'FaxesEmail';
  enableBodyProcess?: Maybe<Scalars['Boolean']['output']>;
  enableProgressFeedback?: Maybe<Scalars['Boolean']['output']>;
  extension?: Maybe<User>;
  extensionId: Scalars['Int']['output'];
  fax?: Maybe<Fax>;
  faxId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  notifyAboutFaxingStarted?: Maybe<Scalars['Boolean']['output']>;
};

export type FaxesEmailList = {
  __typename?: 'FaxesEmailList';
  items: Array<Maybe<FaxesEmail>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum FeatureRestriction {
  CallRejections = 'CALL_REJECTIONS',
  CallRoutings = 'CALL_ROUTINGS',
  Locking = 'LOCKING',
  NumberPresentation = 'NUMBER_PRESENTATION',
  SpeedDials = 'SPEED_DIALS'
}

export enum FeatureState {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Preview = 'PREVIEW'
}

export type Features = {
  __typename?: 'Features';
  alias: FeatureState;
  auditLog: FeatureState;
  callCenterStatistics: FeatureState;
  callOriginationTerminationDenied: FeatureState;
  /** Including domain background color. */
  domainBackgroundImage: FeatureState;
  domainBaseColor: FeatureState;
  domainLoginImage: FeatureState;
  domainLogo: FeatureState;
  domainServiceCodeSetting: FeatureState;
  editableServiceCodes: FeatureState;
  emergencyPrefix: FeatureState;
  enableCarrierAccessCodes: FeatureState;
  hotNumber: FeatureState;
  maliciousCallTrace: FeatureState;
  phoneClient: FeatureState;
  residentialDomains: FeatureState;
};

export type FoundDomain = {
  __typename?: 'FoundDomain';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FoundEndpoint = {
  __typename?: 'FoundEndpoint';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type FoundNumber = {
  __typename?: 'FoundNumber';
  domain: FoundDomain;
  e164?: Maybe<Scalars['String']['output']>;
  endpoint: FoundEndpoint;
  id: Scalars['Int']['output'];
  macAddress?: Maybe<Scalars['String']['output']>;
  shortNumber: Scalars['String']['output'];
};

export type Gateway = {
  __typename?: 'Gateway';
  callbackNumber?: Maybe<Number>;
  callbackNumberId?: Maybe<Scalars['Int']['output']>;
  callbackType: CallbackType;
  clientInfo?: Maybe<Scalars['String']['output']>;
  contactAddress?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  lastCallDirection?: Maybe<Scalars['String']['output']>;
  lastCallTime?: Maybe<Scalars['String']['output']>;
  multipleCallsNumber: Scalars['Int']['output'];
  number?: Maybe<Number>;
  numberId: Scalars['Int']['output'];
  outgoingCallBarringOperator?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  registrationExpireTime?: Maybe<Scalars['DateTime']['output']>;
  registrationTime?: Maybe<Scalars['DateTime']['output']>;
  sipPassword: Scalars['String']['output'];
  sipUser: Scalars['String']['output'];
};

export type GatewayList = {
  __typename?: 'GatewayList';
  items: Array<Maybe<Gateway>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GatewayRetarget = {
  /** The number ID of the new target. */
  newTargetNumberId: Scalars['Int']['input'];
  /** The ID of the referrer of the user. */
  referrerId: Scalars['Int']['input'];
};

export type GatewayRetargets = {
  /** New reference targets for users. */
  users: Array<InputMaybe<GatewayRetarget>>;
};

export type GatewayRouting = {
  /** A description for the routing. */
  comment: Scalars['String']['input'];
  /** ID of a destination. */
  destinationId: Scalars['Int']['input'];
  /** ID of a gateway. */
  gatewayId: Scalars['Int']['input'];
  /** ID of the routing. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The direction of the gateway's last call. */
  lastCallDirection?: InputMaybe<Scalars['String']['input']>;
  /** The gateway's last call time. */
  lastCallTime?: InputMaybe<Scalars['Time']['input']>;
  /** Priority of the routing. */
  priority: Scalars['Int']['input'];
};

export type GatewayStatus = {
  __typename?: 'GatewayStatus';
  clientInfo?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  e164?: Maybe<Scalars['String']['output']>;
  gatewayId: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  registrationExpireTime?: Maybe<Scalars['DateTime']['output']>;
  registrationTime?: Maybe<Scalars['DateTime']['output']>;
  shortNumber?: Maybe<Scalars['String']['output']>;
};

export type Generic = {
  __typename?: 'Generic';
  ssoUrl: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GlobalNumberSearchResult = {
  __typename?: 'GlobalNumberSearchResult';
  /** Indicates if there are more results available beyond the returned list. */
  hasMore: Scalars['Boolean']['output'];
  /** The list of found numbers matching the search criteria. */
  numbers: Array<FoundNumber>;
};

export type Group = {
  __typename?: 'Group';
  group?: Maybe<CallGroupType>;
  groupType: GroupType;
  hasAddressBook: Scalars['Boolean']['output'];
  huntingAlgorithmType: HuntingAlgorithmType;
  id: Scalars['Int']['output'];
  maxQueueLength: Scalars['Int']['output'];
  maxWaitingTime: Scalars['Int']['output'];
  members: Array<GroupMembership>;
  name: Scalars['String']['output'];
  number?: Maybe<Number>;
  numberId: Scalars['Int']['output'];
  outgoingCallBarringAdmin?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringOperator?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  overflowNumber?: Maybe<Number>;
  overflowNumberId?: Maybe<Scalars['Int']['output']>;
  pickup: Scalars['Boolean']['output'];
  sequentialTimeout?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<GroupState>;
};

export enum GroupFilterType {
  CallGroup = 'CALL_GROUP',
  CallQueue = 'CALL_QUEUE',
  Pickup = 'PICKUP'
}

export type GroupList = {
  __typename?: 'GroupList';
  items: Array<Maybe<Group>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GroupMembership = {
  __typename?: 'GroupMembership';
  allowEditAddressBook: Scalars['Boolean']['output'];
  callOrder?: Maybe<Scalars['Int']['output']>;
  controllingLine: Scalars['Boolean']['output'];
  group?: Maybe<Group>;
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  number?: Maybe<Number>;
  numberId: Scalars['Int']['output'];
  sectionIndex: Scalars['Int']['output'];
  state: Scalars['String']['output'];
};

export type GroupMembershipList = {
  __typename?: 'GroupMembershipList';
  items: Array<Maybe<GroupMembership>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum GroupState {
  Closed = 'CLOSED',
  None = 'NONE',
  Open = 'OPEN'
}

export enum GroupType {
  CallQueue = 'CALL_QUEUE',
  Internal = 'INTERNAL',
  Parallel = 'PARALLEL',
  Serial = 'SERIAL'
}

export type GroupsQueue = {
  __typename?: 'GroupsQueue';
  acwLength?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<Group>;
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  queueFullMsg?: Maybe<Scalars['Int']['output']>;
  queueTimeoutMsg?: Maybe<Scalars['Int']['output']>;
  waitInQueueMsg?: Maybe<Scalars['Int']['output']>;
};

export type GroupsQueueList = {
  __typename?: 'GroupsQueueList';
  items: Array<Maybe<GroupsQueue>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum HuntingAlgorithmType {
  Circle = 'CIRCLE',
  Linear = 'LINEAR',
  NonForced = 'NON_FORCED',
  Ucd = 'UCD'
}

export type Ivr = {
  __typename?: 'Ivr';
  callLimit: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  number?: Maybe<Number>;
  numberId: Scalars['Int']['output'];
  outgoingCallBarringAdmin?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringOperator?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringUser?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  privateCallerAnnouncement?: Maybe<Media>;
  privateCallerAnnouncementId?: Maybe<Scalars['Int']['output']>;
  profiles: Array<IvrProfile>;
  recordingType: DirectionType;
};

export type IvrAction = {
  __typename?: 'IvrAction';
  button: Scalars['Int']['output'];
  connectionPrompt?: Maybe<Media>;
  connectionPromptId?: Maybe<Scalars['Int']['output']>;
  downloadToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ivrActionType?: Maybe<IvrActionType>;
  ivrProfile?: Maybe<IvrProfile>;
  ivrProfileId: Scalars['Int']['output'];
  targetNumber?: Maybe<Scalars['String']['output']>;
  targetNumber1?: Maybe<Number>;
  targetNumberId?: Maybe<Scalars['Int']['output']>;
};

export enum IvrActionType {
  BackToGreeting = 'BACK_TO_GREETING',
  BackToMenu = 'BACK_TO_MENU',
  BackToPreviousMenu = 'BACK_TO_PREVIOUS_MENU',
  BackToTopMenu = 'BACK_TO_TOP_MENU',
  DialNumber = 'DIAL_NUMBER',
  Disconnect = 'DISCONNECT',
  Forward = 'FORWARD',
  ForwardToIvr = 'FORWARD_TO_IVR',
  PlayConnectionPrompt = 'PLAY_CONNECTION_PROMPT',
  SelectNumber = 'SELECT_NUMBER',
  Submenu = 'SUBMENU'
}

export type IvrGreeting = {
  __typename?: 'IvrGreeting';
  disabled: Scalars['Boolean']['output'];
  downloadToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isGreeting: Scalars['Boolean']['output'];
  ivrProfile?: Maybe<IvrProfile>;
  ivrProfileId: Scalars['Int']['output'];
  media?: Maybe<Media>;
  mediaId: Scalars['Int']['output'];
  orderNumber: Scalars['Int']['output'];
};

export type IvrList = {
  __typename?: 'IvrList';
  items: Array<Maybe<Ivr>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type IvrMandatoryRelation = {
  __typename?: 'IvrMandatoryRelation';
  e164?: Maybe<Scalars['E164']['output']>;
  id: Scalars['Int']['output'];
  relatedNumberId?: Maybe<Scalars['Int']['output']>;
};

export type IvrMandatoryRelations = {
  __typename?: 'IvrMandatoryRelations';
  gateways?: Maybe<Array<Maybe<IvrMandatoryRelation>>>;
  users?: Maybe<Array<Maybe<IvrMandatoryRelation>>>;
};

export type IvrProfile = {
  __typename?: 'IvrProfile';
  actions: Array<IvrAction>;
  activationTimes: Array<IvrProfileActivationTime>;
  active: Scalars['Boolean']['output'];
  greetings: Array<IvrGreeting>;
  id: Scalars['Int']['output'];
  instantConnect: Scalars['Boolean']['output'];
  ivr?: Maybe<Ivr>;
  ivrId: Scalars['Int']['output'];
  mainParent?: Maybe<IvrProfile>;
  mainParentId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  specialDays: Array<IvrProfileSpecialDay>;
  stickyProfile: Scalars['Boolean']['output'];
  submenus: Array<IvrProfile>;
  timeout: Scalars['Int']['output'];
};

export type IvrProfileActivationTime = {
  __typename?: 'IvrProfileActivationTime';
  activationTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  weekday: Weekday;
};

export type IvrProfileSettings = {
  /** Activation values for the profile */
  activationTimes?: InputMaybe<Array<InputMaybe<ActivationTime>>>;
  /** List of the profile's special days */
  specialDays?: InputMaybe<Array<InputMaybe<ProfileSpecialDay>>>;
  /** Profile is sticky or not. A sticky profile active status is not changing automatically. */
  stickyProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IvrProfileSpecialDay = {
  __typename?: 'IvrProfileSpecialDay';
  activationTime?: Maybe<Scalars['String']['output']>;
  day: Scalars['String']['output'];
  everyYear: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
};

export type LimitInfo = {
  __typename?: 'LimitInfo';
  canAdd: Scalars['Boolean']['output'];
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type LimitsFeatures = {
  __typename?: 'LimitsFeatures';
  auditLog: Scalars['Boolean']['output'];
  billing: Scalars['Boolean']['output'];
  callCenterStatistics: Scalars['Boolean']['output'];
  callQueue: Scalars['Boolean']['output'];
  sipUris: Scalars['Boolean']['output'];
};

export type LimitsQuota = {
  __typename?: 'LimitsQuota';
  allocated: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** The system limit for this quota. None if it is unlimited. */
  systemLimit?: Maybe<Scalars['Int']['output']>;
  used: Scalars['Float']['output'];
};

export type LimitsSummary = {
  __typename?: 'LimitsSummary';
  capabilitySets: Array<LimitsQuota>;
  deviceTypeSets: Array<LimitsQuota>;
  features: LimitsFeatures;
  packages: Array<LimitsQuota>;
  services: Array<LimitsQuota>;
  validity: LimitsValidity;
};

export type LimitsValidity = {
  __typename?: 'LimitsValidity';
  expirationDate?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Array<Scalars['String']['output']>>;
  issuedFor: Scalars['String']['output'];
};

export type LinkedDevice = {
  __typename?: 'LinkedDevice';
  id: Scalars['Int']['output'];
  /** MAC address of the linked device. */
  macAddress: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** List of agent state changes */
export type ListOfChanges = {
  __typename?: 'ListOfChanges';
  changes: Array<StateChange>;
  cursor?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Error>>;
  hasNext: Scalars['Boolean']['output'];
};

export type Location = {
  __typename?: 'Location';
  bandwidthLimit: Scalars['Int']['output'];
  callLimit: Scalars['Int']['output'];
  canBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  domain?: Maybe<Domain>;
  domainId: Scalars['Int']['output'];
  emergencyPrefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pilotNumber: Scalars['String']['output'];
};

export type LocationData = {
  /** Bandwidth limit of the location */
  bandwidthLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Parallel call limit of the location */
  callLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The description of the location */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The IP address of the location */
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  /** The name of the location */
  name: Scalars['String']['input'];
  /** The pilot number of the location */
  pilotNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LocationList = {
  __typename?: 'LocationList';
  items: Array<Maybe<Location>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LocationStatus = {
  __typename?: 'LocationStatus';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  statuses: Array<UserStatus>;
};

export type Media = {
  __typename?: 'Media';
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Domain>;
  domainId: Scalars['Int']['output'];
  /** Download token for the media file if has one. */
  downloadToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
};

/**
 * Return object for routes that use media. Named "Info" to avoid confusion about
 *     not using the data field. There is an endpoint on Starlette that returns
 *     only the data field to a specific media by ID. Could not handle this in an other way yet.
 *
 *     Attributes:
 *         `description` (str) -- Description for the media. Usually file name, but can be specified.
 *
 *         `download_token` (str) -- Temporary token for downloading the media. It is valid for 5 minutes.
 *
 */
export type MediaFileInfo = {
  __typename?: 'MediaFileInfo';
  description: Scalars['String']['output'];
  downloadToken: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type MediaList = {
  __typename?: 'MediaList';
  items: Array<Media>;
  totalCount: Scalars['Int']['output'];
};

export enum MediaSortBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DomainIdAsc = 'DOMAIN_ID_ASC',
  DomainIdDesc = 'DOMAIN_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateExtensionProfile?: Maybe<MutationResult>;
  activateIvrProfile: MutationResult;
  activateUserProfile?: Maybe<MutationResult>;
  addAddressBookEntry: MutationResult;
  addAdminRole: MutationResult;
  addDomainAdmins: MutationResult;
  addMedia?: Maybe<SaveResult>;
  addUserLogin?: Maybe<SaveResult>;
  assignUser?: Maybe<Array<Maybe<Error>>>;
  bulkAddressBookModification: BulkAddressBookModificationResult;
  bulkDomainNonPaymentBlocking?: Maybe<MutationResult>;
  bulkUserModification: BulkUserModificationResult;
  createCallGroup: SaveResult;
  createDomain?: Maybe<SaveResult>;
  createFax?: Maybe<SaveResult>;
  createGateway?: Maybe<SaveResult>;
  createIvr?: Maybe<SaveResult>;
  createUser: SaveResult;
  deleteAddressBookEntry: MutationResult;
  deleteCallGroup?: Maybe<MutationResult>;
  deleteClientDevice?: Maybe<Array<Maybe<Error>>>;
  deleteDeviceVariant: Array<Error>;
  deleteExtensionProfileRule?: Maybe<Array<Maybe<Error>>>;
  deleteFax?: Maybe<MutationResult>;
  deleteGateway?: Maybe<Array<Maybe<Error>>>;
  deleteGroupMembership?: Maybe<Array<Maybe<Error>>>;
  deleteIvr?: Maybe<MutationResult>;
  deleteLinkedDevice?: Maybe<Array<Maybe<Error>>>;
  deleteLocation?: Maybe<Array<Maybe<Error>>>;
  deleteMedia: MutationResult;
  deletePickupGroup: Array<Error>;
  deleteProvisionedDevice?: Maybe<Array<Maybe<Error>>>;
  deleteSpeedDial?: Maybe<Array<Maybe<Error>>>;
  deleteThirdPartyDevice?: Maybe<Array<Maybe<Error>>>;
  deleteUser?: Maybe<MutationResult>;
  deleteUserLogin?: Maybe<Array<Maybe<Error>>>;
  deleteUserProfileRule?: Maybe<Array<Maybe<Error>>>;
  deleteVoicemailMessage: SaveResult;
  detectMemoryLeak?: Maybe<Array<Maybe<Error>>>;
  domainAllocationUpdate: MutationResult;
  domainBulkCapabilityUpdate?: Maybe<MutationResult>;
  domainDefaultsUpdate: MutationResult;
  domainQuotaDefaultsUpdate: MutationResult;
  /** Rename a domain */
  domainRename: MutationResult;
  makeOwner?: Maybe<Array<Maybe<Error>>>;
  markVoicemailMessage: SaveResult;
  moveUsers?: Maybe<MutationResult>;
  resendInvitationEmail?: Maybe<MutationResult>;
  resynchronizeProvisionedDevices: DeviceResynchronizeResult;
  revokeAdminRoles?: Maybe<Array<Maybe<Error>>>;
  saveClientDevice?: Maybe<SaveResult>;
  saveDeviceVariant: SaveResult;
  saveExtensionProfileDnd?: Maybe<Array<Maybe<Error>>>;
  saveExtensionProfileRule?: Maybe<SaveResult>;
  saveGroupMembership: SaveResult;
  /** Add or update a location. */
  saveLocation: SaveResult;
  savePhoneButtons: SaveResult;
  savePickupGroup: SaveResult;
  saveProvisionedDevice?: Maybe<SaveResult>;
  saveSpeedDial?: Maybe<SaveResult>;
  saveThirdPartyDevice?: Maybe<SaveResult>;
  saveUserProfileDnd?: Maybe<Array<Maybe<Error>>>;
  saveUserProfileRule?: Maybe<SaveResult>;
  synchronizeDomainAddressBook: SynchronizeDomainAddressBookResult;
  synchronizeFax?: Maybe<SynchronizeFaxResult>;
  updateAddressBookEntry: MutationResult;
  updateCallGroup?: Maybe<SaveResult>;
  updateCallQueue?: Maybe<SaveResult>;
  updateDomainE164Ranges: MutationResult;
  updateDomainSettings: MutationResult;
  updateExtension?: Maybe<UpdateUserResult>;
  updateExtensionProfile?: Maybe<MutationResult>;
  updateFax?: Maybe<MutationResult>;
  updateGateway?: Maybe<MutationResult>;
  updateGatewayRouting?: Maybe<MutationResult>;
  updateIvr?: Maybe<MutationResult>;
  updateIvrProfile?: Maybe<MutationResult>;
  updateMedia?: Maybe<MutationResult>;
  updatePrivateRoutingDestinations?: Maybe<MutationResult>;
  updateProvisionedDeviceImplementor?: Maybe<SaveResult>;
  updateSpecialDays?: Maybe<MutationResult>;
  updateSystemSettings: MutationResult;
  updateUser?: Maybe<UpdateUserResult>;
  /** Update user limit. */
  updateUserLimit: MutationResult;
  updateUserProfile?: Maybe<MutationResult>;
};


export type MutationActivateExtensionProfileArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationActivateIvrProfileArgs = {
  id: Scalars['Int']['input'];
};


export type MutationActivateUserProfileArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddAddressBookEntryArgs = {
  entry: AddressBookEntryData;
  target: Scalars['String']['input'];
};


export type MutationAddAdminRoleArgs = {
  canCreateEndpoints: Scalars['Boolean']['input'];
  domainId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  language?: Scalars['String']['input'];
};


export type MutationAddDomainAdminsArgs = {
  domainAdmins: Array<DomainAdminInput>;
  domainId: Scalars['Int']['input'];
};


export type MutationAddMediaArgs = {
  description: Scalars['String']['input'];
  domainId: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationAddUserLoginArgs = {
  loginData: CreateUserLoginInput;
};


export type MutationAssignUserArgs = {
  locationId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationBulkAddressBookModificationArgs = {
  domainId: Scalars['Int']['input'];
  entries: Array<AddressBookEntryData>;
};


export type MutationBulkDomainNonPaymentBlockingArgs = {
  id: Scalars['Int']['input'];
  value: NonPaymentBlockingType;
};


export type MutationBulkUserModificationArgs = {
  domainId: Scalars['Int']['input'];
  locations: Array<LocationData>;
  profileNames: Array<Scalars['String']['input']>;
  users: Array<BulkUserModificationData>;
};


export type MutationCreateCallGroupArgs = {
  domainId: Scalars['Int']['input'];
  e164?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<Array<CreateCallGroupMember>>>;
  name: Scalars['String']['input'];
  pickup?: Scalars['Boolean']['input'];
  sequentialTimeout?: Scalars['Int']['input'];
  shortNumber: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  type: CallGroupType;
};


export type MutationCreateDomainArgs = {
  defaultUserPackage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dialoutPrefix?: InputMaybe<Scalars['String']['input']>;
  domainType: DomainType;
  locationDescription: Scalars['String']['input'];
  locationName: Scalars['String']['input'];
  locationPilotNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  preferDisplayNamesForStationNames: Scalars['Boolean']['input'];
  privateRoutingType: PrivateRoutingType;
  shortNumbersLength: Scalars['Int']['input'];
  smtpAuthEnabled: Scalars['Boolean']['input'];
  smtpUsername?: InputMaybe<Scalars['String']['input']>;
  smtpUserpass?: InputMaybe<Scalars['String']['input']>;
  specialNumbersDialoutPrefix?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFaxArgs = {
  additionalFaxSendingEmails: Array<InputMaybe<Scalars['String']['input']>>;
  domainId: Scalars['Int']['input'];
  e164?: InputMaybe<Scalars['String']['input']>;
  incomingEmailAddress: Scalars['String']['input'];
  notifyUnsuccessfulReceiving: Scalars['Boolean']['input'];
  outgoingCallBarringAdmin?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  outgoingCallBarringOperator?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  password: Scalars['String']['input'];
  senderEmailAddress?: InputMaybe<Scalars['String']['input']>;
  shortNumber: Scalars['String']['input'];
};


export type MutationCreateGatewayArgs = {
  callbackNumberId: Scalars['Int']['input'];
  displayName: Scalars['String']['input'];
  domainId: Scalars['Int']['input'];
  e164?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  shortNumber: Scalars['String']['input'];
  sipPassword: Scalars['String']['input'];
  sipUser: Scalars['String']['input'];
};


export type MutationCreateIvrArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  e164?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  data: CreateUserData;
};


export type MutationDeleteAddressBookEntryArgs = {
  cn: Scalars['String']['input'];
  target: Scalars['String']['input'];
};


export type MutationDeleteCallGroupArgs = {
  id: Scalars['Int']['input'];
  relatedData: CallGroupRetargets;
};


export type MutationDeleteClientDeviceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDeviceVariantArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteExtensionProfileRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFaxArgs = {
  id: Scalars['Int']['input'];
  relatedData: FaxRetargets;
};


export type MutationDeleteGatewayArgs = {
  gatewayId: Scalars['Int']['input'];
  relatedData: GatewayRetargets;
};


export type MutationDeleteGroupMembershipArgs = {
  groupId: Scalars['Int']['input'];
  numberId: Scalars['Int']['input'];
};


export type MutationDeleteIvrArgs = {
  id: Scalars['Int']['input'];
  relatedData?: InputMaybe<ReferenceRetargetsIvr>;
};


export type MutationDeleteLinkedDeviceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMediaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePickupGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProvisionedDeviceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteSpeedDialArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteThirdPartyDeviceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteUserArgs = {
  deleteChatHistory?: InputMaybe<Scalars['Boolean']['input']>;
  deletePersonalAddressbook?: InputMaybe<Scalars['Boolean']['input']>;
  deletePresenceData?: InputMaybe<Scalars['Boolean']['input']>;
  deleteVoicemailHistory?: InputMaybe<Scalars['Boolean']['input']>;
  relatedData?: InputMaybe<ReferenceRetargetsUser>;
  userId: Scalars['Int']['input'];
};


export type MutationDeleteUserLoginArgs = {
  userId: Scalars['Int']['input'];
  userSub: Scalars['String']['input'];
};


export type MutationDeleteUserProfileRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteVoicemailMessageArgs = {
  userId: Scalars['Int']['input'];
  voicemailId: Scalars['Int']['input'];
};


export type MutationDomainAllocationUpdateArgs = {
  capabilitySets?: InputMaybe<Array<AllocationInput>>;
  deviceTypeSets?: InputMaybe<Array<AllocationInput>>;
  domainId: Scalars['Int']['input'];
  services?: InputMaybe<ServicesAllocationInput>;
  userPackages?: InputMaybe<Array<AllocationInput>>;
};


export type MutationDomainBulkCapabilityUpdateArgs = {
  changes: Array<InputMaybe<CapabilityModification>>;
  domainId: Scalars['Int']['input'];
};


export type MutationDomainDefaultsUpdateArgs = {
  deviceVariantId?: InputMaybe<Scalars['Int']['input']>;
  domainId: Scalars['Int']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDomainQuotaDefaultsUpdateArgs = {
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  devices?: InputMaybe<Array<AllocationInput>>;
  domainId: Scalars['Int']['input'];
  userPackageName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDomainRenameArgs = {
  domainId: Scalars['Int']['input'];
  newName: Scalars['String']['input'];
};


export type MutationMakeOwnerArgs = {
  userId: Scalars['Int']['input'];
  userSub: Scalars['String']['input'];
};


export type MutationMarkVoicemailMessageArgs = {
  userId: Scalars['Int']['input'];
  voicemailId: Scalars['Int']['input'];
};


export type MutationMoveUsersArgs = {
  destinationLocationId: Scalars['Int']['input'];
  sourceLocationId: Scalars['Int']['input'];
};


export type MutationResendInvitationEmailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationResynchronizeProvisionedDevicesArgs = {
  deviceIdList: Array<Scalars['Int']['input']>;
};


export type MutationRevokeAdminRolesArgs = {
  domainId: Scalars['Int']['input'];
  userSubs: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSaveClientDeviceArgs = {
  clientInfo?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<ClientType>;
  description?: InputMaybe<Scalars['String']['input']>;
  extensionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveDeviceVariantArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveExtensionProfileDndArgs = {
  clientDeviceId: Scalars['Int']['input'];
  profiles: Array<InputMaybe<ExtensionProfileDnd>>;
};


export type MutationSaveExtensionProfileRuleArgs = {
  data: UserProfileRuleData;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveGroupMembershipArgs = {
  allowEditAddressBook?: Scalars['Boolean']['input'];
  callOrder?: InputMaybe<Scalars['Int']['input']>;
  controllingLine?: Scalars['Boolean']['input'];
  groupId: Scalars['Int']['input'];
  numberId: Scalars['Int']['input'];
  overrideNumber?: Scalars['Boolean']['input'];
  sectionIndex?: InputMaybe<Scalars['Int']['input']>;
  state?: ControllingLineState;
};


export type MutationSaveLocationArgs = {
  bandwidthLimit?: InputMaybe<Scalars['Int']['input']>;
  callLimit?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domainId?: InputMaybe<Scalars['Int']['input']>;
  emergencyPrefix?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pilotNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSavePhoneButtonsArgs = {
  buttons: Array<PhoneButtonInput>;
  provisionedDeviceId: Scalars['Int']['input'];
};


export type MutationSavePickupGroupArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};


export type MutationSaveProvisionedDeviceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  macAddress?: InputMaybe<Scalars['String']['input']>;
  provisioning?: InputMaybe<Scalars['Boolean']['input']>;
  useDisplayNameForStationName?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveSpeedDialArgs = {
  speedDialInput: SpeedDialInput;
};


export type MutationSaveThirdPartyDeviceArgs = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  sipPassword: Scalars['String']['input'];
  sipUser: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveUserProfileDndArgs = {
  clientDeviceId: Scalars['Int']['input'];
  profiles: Array<InputMaybe<UserProfileDnd>>;
};


export type MutationSaveUserProfileRuleArgs = {
  data: UserProfileRuleData;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSynchronizeDomainAddressBookArgs = {
  domainId: Scalars['Int']['input'];
};


export type MutationSynchronizeFaxArgs = {
  domainId: Scalars['Int']['input'];
};


export type MutationUpdateAddressBookEntryArgs = {
  cn: Scalars['String']['input'];
  entry: AddressBookEntryData;
  target: Scalars['String']['input'];
};


export type MutationUpdateCallGroupArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  outgoingCallBarringAdmin?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  outgoingCallBarringOperator?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  pickup?: InputMaybe<Scalars['Boolean']['input']>;
  sequentialTimeout?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CallGroupType>;
};


export type MutationUpdateCallQueueArgs = {
  acwLength?: InputMaybe<Scalars['Int']['input']>;
  hasAddressBook?: InputMaybe<Scalars['Boolean']['input']>;
  huntingAlgorithmType?: InputMaybe<HuntingAlgorithmType>;
  id: Scalars['Int']['input'];
  maxQueueLength?: InputMaybe<Scalars['Int']['input']>;
  maxWaitingTime?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outgoingCallBarringAdmin?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  outgoingCallBarringOperator?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  queueFull?: InputMaybe<CallQueueMedia>;
  queueTimeout?: InputMaybe<CallQueueMedia>;
  sequentialTimeout?: InputMaybe<Scalars['Int']['input']>;
  waiting?: InputMaybe<CallQueueMedia>;
};


export type MutationUpdateDomainE164RangesArgs = {
  id: Scalars['Int']['input'];
  ranges: Array<E164Range>;
};


export type MutationUpdateDomainSettingsArgs = {
  input: DomainSettingsInput;
};


export type MutationUpdateExtensionArgs = {
  data: UpdateExtensionData;
  id: Scalars['Int']['input'];
};


export type MutationUpdateExtensionProfileArgs = {
  data: UpdateUserProfileData;
  id: Scalars['Int']['input'];
};


export type MutationUpdateFaxArgs = {
  additionalFaxSendingEmails: AdditionalFaxSendingEmails;
  headerInfo?: InputMaybe<Scalars['String']['input']>;
  headerNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  incomingEmailAddress: Scalars['String']['input'];
  nonPaymentBlockingType?: InputMaybe<NonPaymentBlockingType>;
  notifyUnsuccessfulReceiving: Scalars['Boolean']['input'];
  outgoingCallBarringAdmin?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  outgoingCallBarringOperator?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  password: Scalars['String']['input'];
  senderEmailAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateGatewayArgs = {
  data: UpdateGatewayData;
  id: Scalars['Int']['input'];
};


export type MutationUpdateGatewayRoutingArgs = {
  domainId: Scalars['Int']['input'];
  gatewayRoutings: Array<InputMaybe<GatewayRouting>>;
};


export type MutationUpdateIvrArgs = {
  callLimit?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nonPaymentBlockingType?: InputMaybe<NonPaymentBlockingType>;
  outgoingCallBarringAdmin?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  outgoingCallBarringOperator?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  privateCallerAnnouncement?: InputMaybe<UpdateIvrAnnouncement>;
  recordingType?: InputMaybe<DirectionType>;
};


export type MutationUpdateIvrProfileArgs = {
  buttons?: InputMaybe<Array<InputMaybe<UpdateIvrButton>>>;
  greetings?: InputMaybe<Array<InputMaybe<UpdateIvrMenuMedia>>>;
  id: Scalars['Int']['input'];
  instantConnect?: InputMaybe<Scalars['Boolean']['input']>;
  menuMedia?: InputMaybe<Array<InputMaybe<UpdateIvrMenuMedia>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<IvrProfileSettings>;
  submenus?: InputMaybe<Array<InputMaybe<SubmenuSettings>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateMediaArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationUpdatePrivateRoutingDestinationsArgs = {
  destinations: Array<InputMaybe<DestinationModel>>;
};


export type MutationUpdateProvisionedDeviceImplementorArgs = {
  currentMacAddress?: InputMaybe<Scalars['String']['input']>;
  newMacAddress: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  vendorId: Scalars['Int']['input'];
};


export type MutationUpdateSpecialDaysArgs = {
  days: Array<InputMaybe<OverrideDay>>;
};


export type MutationUpdateSystemSettingsArgs = {
  preserveCallRecordsFor?: InputMaybe<Scalars['Int']['input']>;
  preserveCcPresenceChangesFor?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserData;
  id: Scalars['Int']['input'];
};


export type MutationUpdateUserLimitArgs = {
  capabilitySets?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceTypeSets?: InputMaybe<Array<UpdateDeviceTypeSetLimit>>;
  id: Scalars['Int']['input'];
  userPackageName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserProfileArgs = {
  data: UpdateUserProfileData;
  id: Scalars['Int']['input'];
};

export type MutationResult = {
  __typename?: 'MutationResult';
  errors?: Maybe<Array<Error>>;
};

export enum NonPaymentBlockingType {
  IncomingAndOutgoingBlocked = 'INCOMING_AND_OUTGOING_BLOCKED',
  NotBlocked = 'NOT_BLOCKED',
  OutgoingBlocked = 'OUTGOING_BLOCKED'
}

export type Number = {
  __typename?: 'Number';
  callOriginationDenied: Scalars['Boolean']['output'];
  callTerminationDenied: Scalars['Boolean']['output'];
  clientInfo?: Maybe<Scalars['String']['output']>;
  collectStatistics: DirectionType;
  domain: Domain;
  domainId: Scalars['Int']['output'];
  e164?: Maybe<Scalars['E164']['output']>;
  enabled: Scalars['Boolean']['output'];
  extension?: Maybe<User>;
  groupCircularSelectLastTs?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  nonPaymentBlockingType: NonPaymentBlockingType;
  numberType: NumberType;
  shortNumber?: Maybe<Scalars['String']['output']>;
};

export type NumberDomainIdE164 = {
  __typename?: 'NumberDomainIdE164';
  domainId: Scalars['Int']['output'];
  e164?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export enum NumberType {
  Extension = 'EXTENSION',
  Fax = 'FAX',
  Gateway = 'GATEWAY',
  Group = 'GROUP',
  GroupInternal = 'GROUP_INTERNAL',
  Ivr = 'IVR'
}

export type NumberingPlan = {
  __typename?: 'NumberingPlan';
  destination?: Maybe<Destination>;
  destinationId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
};

export enum OutgoingCallBarring {
  Custom_1 = 'CUSTOM_1',
  Custom_2 = 'CUSTOM_2',
  Custom_3 = 'CUSTOM_3',
  DomesticMobile = 'DOMESTIC_MOBILE',
  Donation = 'DONATION',
  Emergency = 'EMERGENCY',
  Information = 'INFORMATION',
  International = 'INTERNATIONAL',
  LocalBlue = 'LOCAL_BLUE',
  NonLocal = 'NON_LOCAL',
  OtherOperator = 'OTHER_OPERATOR',
  Premium = 'PREMIUM'
}

export type OverrideDay = {
  considerAs: Weekday;
  day: Scalars['Date']['input'];
  everyYear: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonalUser = {
  __typename?: 'PersonalUser';
  domain: FoundDomain;
  e164?: Maybe<Scalars['E164']['output']>;
  id: Scalars['Int']['output'];
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberId: Scalars['Int']['output'];
  shortNumber: Scalars['String']['output'];
};

export type PhoneButton = {
  __typename?: 'PhoneButton';
  buttonPosition: Scalars['Int']['output'];
  buttonType: PhoneButtonType;
  display?: Maybe<Scalars['String']['output']>;
  speedDialNumber?: Maybe<Scalars['String']['output']>;
  targetNumberId?: Maybe<Scalars['Int']['output']>;
};

export type PhoneButtonInput = {
  buttonPosition: Scalars['Int']['input'];
  buttonType: PhoneButtonType;
  display?: InputMaybe<Scalars['String']['input']>;
  speedDialNumber?: InputMaybe<Scalars['String']['input']>;
  targetNumberId?: InputMaybe<Scalars['Int']['input']>;
};

export enum PhoneButtonType {
  Blf = 'BLF',
  BlfGroup = 'BLF_GROUP',
  Callpark = 'CALLPARK',
  Empty = 'EMPTY',
  Line = 'LINE',
  SpeedDial = 'SPEED_DIAL'
}

/** Available user for pickup group. */
export type PickupGroupUser = {
  __typename?: 'PickupGroupUser';
  displayName: Scalars['String']['output'];
  numberId: Scalars['Int']['output'];
  shortNumber: Scalars['String']['output'];
};

export type PrivateRouting = {
  __typename?: 'PrivateRouting';
  comment?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Destination>;
  destinationId: Scalars['Int']['output'];
  gateway?: Maybe<Gateway>;
  gatewayId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
};

export type PrivateRoutingList = {
  __typename?: 'PrivateRoutingList';
  items: Array<Maybe<PrivateRouting>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum PrivateRoutingType {
  GatewayOnly = 'GATEWAY_ONLY',
  GatewayWithPstnFallback = 'GATEWAY_WITH_PSTN_FALLBACK',
  PstnOnly = 'PSTN_ONLY'
}

export type ProfileSpecialDay = {
  /** Time of the activation for the special day */
  activationTime?: InputMaybe<Scalars['Time']['input']>;
  /** Date of the activation for the special day */
  day: Scalars['Date']['input'];
  /** Use this activation time in every year or not */
  everyYear: Scalars['Boolean']['input'];
  /** ID of the special day */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProvisionedDevice = {
  __typename?: 'ProvisionedDevice';
  clientInfo?: Maybe<Scalars['String']['output']>;
  gruu?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  macAddress?: Maybe<Scalars['String']['output']>;
  provisioning: Scalars['Boolean']['output'];
  registrationExpireTime?: Maybe<Scalars['DateTime']['output']>;
  registrationTime?: Maybe<Scalars['DateTime']['output']>;
  sipPassword: Scalars['String']['output'];
  sipUser: Scalars['String']['output'];
  useDisplayNameForStationName: Scalars['Boolean']['output'];
  variant?: Maybe<Scalars['String']['output']>;
  vendor: Vendor;
};

export type Query = {
  __typename?: 'Query';
  addressBook: AddressBookListResult;
  admins?: Maybe<Array<Maybe<Admin>>>;
  /** Get the list of agent state changes. The 'group_id' argument specifies the call queue (it is required). Recent changes can be queried using 'recent: true' argument. Changes can be queried from a cursor, received from a previous query, using 'after: $cursor' argument. The arguments 'recent' and 'after' are mutually exclusive arguments: they cannot be used at the same time. The 'limit' argument defines how many changes can be queried at once, the default (and the maximum) value is 10000. */
  agentStateChanges?: Maybe<ListOfChanges>;
  assignableUsers?: Maybe<Array<Maybe<AssignableUser>>>;
  auditLogs: AuditLogList;
  availablePickupGroupUsers?: Maybe<Array<Maybe<PickupGroupUser>>>;
  availableTranslations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Get the list of calls related to a specified domain. The 'domain_id' argument specifies the domain (it is required). Recent calls can be queried using 'recent: true' argument. Calls can be queried from a cursor, received from a previous query, using 'after: $cursor' argument. The arguments 'recent' and 'after' are mutually exclusive arguments: they cannot be used at the same time. The 'limit' argument defines how many calls can be queried at once, the default (and the maximum) value is 10000. */
  callList: CallList;
  callQueues?: Maybe<Array<Maybe<CallQueue>>>;
  /** Information about user related capability */
  capabilityLimit?: Maybe<CapabilityLimit>;
  capabilitySets?: Maybe<Array<Maybe<CapabilitySet>>>;
  clientDevices: Array<ClientDevice>;
  destination?: Maybe<DestinationList>;
  deviceLimit: Array<DeviceSetLimit>;
  deviceTypeSets: Array<DeviceTypeSet>;
  deviceVariants?: Maybe<DeviceVariantList>;
  documents: Array<Document>;
  domainAllocation: DomainAllocations;
  domainBulkCapability?: Maybe<Array<Maybe<BulkCapabilityModificationInfo>>>;
  domainDefaults: DomainDefaultsInfo;
  domainQuotaDefaults?: Maybe<DomainQuotaDefaultsInfo>;
  domainStatus?: Maybe<DomainStatus>;
  domainSummary: DomainSummary;
  domainTheme?: Maybe<DomainTheme>;
  domains?: Maybe<DomainList>;
  extensionCapabilities?: Maybe<Array<Maybe<Capability>>>;
  extensionProfiles?: Maybe<Array<Maybe<UserProfile>>>;
  extensionProfilesDnd?: Maybe<UserProfiles>;
  extensions?: Maybe<UserList>;
  faxRecords?: Maybe<FaxRecords>;
  faxes?: Maybe<FaxList>;
  faxesEmails?: Maybe<FaxesEmailList>;
  gateways?: Maybe<GatewayList>;
  groupMemberships?: Maybe<GroupMembershipList>;
  groups?: Maybe<GroupList>;
  groupsQueue?: Maybe<GroupsQueueList>;
  ivrMandatoryRelations?: Maybe<IvrMandatoryRelations>;
  ivrs?: Maybe<IvrList>;
  limitsSummary: LimitsSummary;
  linkedDevices?: Maybe<Array<Maybe<LinkedDevice>>>;
  locations?: Maybe<LocationList>;
  locationsToRearrange?: Maybe<Array<Maybe<RearrangeLocation>>>;
  media: MediaList;
  /** id, domainId, e164 of numbers */
  numberDomainIdE164?: Maybe<Array<Maybe<NumberDomainIdE164>>>;
  personalExtensions: Array<PersonalUser>;
  personalUsers: Array<PersonalUser>;
  phoneButtons?: Maybe<Array<Maybe<PhoneButton>>>;
  ping: Scalars['String']['output'];
  privateRouting?: Maybe<PrivateRoutingList>;
  provisionedDevices?: Maybe<Array<Maybe<ProvisionedDevice>>>;
  /**
   * Returns all the groups, auto attendants, phone buttons or extensions
   *     that reference this extension, fax, gateway or call group
   */
  relatedData: References;
  replaceNumberOptions?: Maybe<Array<Maybe<ReplaceOption>>>;
  /** Search for numbers globally by short number, E.164 or MAC address. */
  searchNumbers: GlobalNumberSearchResult;
  /** Generate random SIP user with password */
  sipUser?: Maybe<SipUser>;
  specialDays?: Maybe<SpecialDayList>;
  speedDialShortNumbers: Array<Scalars['String']['output']>;
  speedDials?: Maybe<SpeedDialList>;
  /** Status of the Concerto Web instance */
  status: Status;
  /** Status of the Concerto Web instance */
  structureConfig: StructureConfig;
  supervisedCallQueues: Array<SupervisedCallQueueInfo>;
  systemSettings: SystemSettings;
  /** Returns list of ThirdPartyDevice related to given User */
  thirdPartyDevices?: Maybe<Array<Maybe<ThirdPartyDevice>>>;
  translations?: Maybe<Scalars['String']['output']>;
  userBasicInfo?: Maybe<UserBasicInfo>;
  userCapabilities?: Maybe<Array<Maybe<Capability>>>;
  userEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userLogins?: Maybe<Array<Maybe<UserLogin>>>;
  userOwner?: Maybe<UserOwner>;
  /** List of packages that are available */
  userPackages: Array<UserPackageInfo>;
  userProfiles?: Maybe<Array<Maybe<UserProfile>>>;
  userProfilesDnd?: Maybe<UserProfiles>;
  userQuotaInfo?: Maybe<UserQuotaInfo>;
  /** List of roles that are available to the user. */
  userRoles: Array<Role>;
  userTheme?: Maybe<DomainTheme>;
  users?: Maybe<UserList>;
  /**
   *
   * Query the users of a domain for bulk modification. Use this
   * query to get the additional information needed to perform bulk
   * modifications.
   *
   */
  usersBulk: Array<BulkUserInfo>;
  usersCapabilities?: Maybe<Array<Maybe<UserCapabilities>>>;
  vendors?: Maybe<Array<Maybe<Vendor>>>;
  voicemailMessage?: Maybe<Scalars['String']['output']>;
  voicemails: VoicemailList;
};


export type QueryAddressBookArgs = {
  changesSince?: InputMaybe<Scalars['String']['input']>;
  filterValue?: Scalars['String']['input'];
  target: Scalars['String']['input'];
};


export type QueryAdminsArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryAgentStateChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  collectConferenceMembers?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<StateChangeTimeInterval>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  recent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssignableUsersArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryAuditLogsArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  numberOrActorFilter?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  sortBy?: InputMaybe<Array<AuditLogsSortBy>>;
};


export type QueryAvailablePickupGroupUsersArgs = {
  groupId: Scalars['Int']['input'];
};


export type QueryCallListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  collectConferenceMembers?: Scalars['Boolean']['input'];
  domainId?: InputMaybe<Scalars['Int']['input']>;
  filterValue?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<CallListInterval>;
  limit?: Scalars['Int']['input'];
  numberId?: InputMaybe<Scalars['Int']['input']>;
  recent?: Scalars['Boolean']['input'];
  recordingIdFilter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCallQueuesArgs = {
  domainId: Scalars['Int']['input'];
  groupId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCapabilityLimitArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryClientDevicesArgs = {
  extensionId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDestinationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDeviceLimitArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryDeviceVariantsArgs = {
  domainIdOrNone?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDomainAllocationArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryDomainBulkCapabilityArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryDomainDefaultsArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryDomainQuotaDefaultsArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryDomainStatusArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryDomainSummaryArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryDomainThemeArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryDomainsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryExtensionCapabilitiesArgs = {
  extensionId: Scalars['Int']['input'];
};


export type QueryExtensionProfilesArgs = {
  extensionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notExtensionId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExtensionProfilesDndArgs = {
  clientDeviceId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExtensionsArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  notLocationId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFaxRecordsArgs = {
  direction: FaxDirection;
  id: Scalars['Int']['input'];
  interval?: InputMaybe<FaxRecordsInterval>;
};


export type QueryFaxesArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFaxesEmailsArgs = {
  faxIdOrNone?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGatewaysArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGroupMembershipsArgs = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notGroupId?: InputMaybe<Scalars['Int']['input']>;
  notNumberId?: InputMaybe<Scalars['Int']['input']>;
  numberId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGroupsArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  memberNumberId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  notNumberId?: InputMaybe<Scalars['Int']['input']>;
  numberId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<GroupFilterType>;
};


export type QueryGroupsQueueArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryIvrMandatoryRelationsArgs = {
  ivrId: Scalars['Int']['input'];
};


export type QueryIvrsArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showSubMenus?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLinkedDevicesArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryLocationsArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notDomainId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  notName?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLocationsToRearrangeArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryMediaArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<MediaSortBy>>;
};


export type QueryNumberDomainIdE164Args = {
  e164?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPhoneButtonsArgs = {
  provisionedDeviceId: Scalars['Int']['input'];
};


export type QueryPrivateRoutingArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProvisionedDevicesArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryRelatedDataArgs = {
  id: Scalars['Int']['input'];
  numberType: NumberType;
};


export type QueryReplaceNumberOptionsArgs = {
  e164Only?: InputMaybe<Scalars['Boolean']['input']>;
  nameFilter?: InputMaybe<Scalars['String']['input']>;
  numberId: Scalars['Int']['input'];
  numberTypes: Array<InputMaybe<ReplaceNumberOptionType>>;
};


export type QuerySearchNumbersArgs = {
  filterString: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
};


export type QuerySpecialDaysArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySpeedDialShortNumbersArgs = {
  speedDialId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type QuerySpeedDialsArgs = {
  extensionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notExtensionId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySupervisedCallQueuesArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryThirdPartyDevicesArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryTranslationsArgs = {
  locale: Scalars['String']['input'];
};


export type QueryUserBasicInfoArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserCapabilitiesArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserLoginsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserOwnerArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserProfilesArgs = {
  extensionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  notExtensionId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserProfilesDndArgs = {
  clientDeviceId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserQuotaInfoArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserThemeArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  notId?: InputMaybe<Scalars['Int']['input']>;
  notLocationId?: InputMaybe<Scalars['Int']['input']>;
  notNumberId?: InputMaybe<Scalars['Int']['input']>;
  numberId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersBulkArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryUsersCapabilitiesArgs = {
  domainId: Scalars['Int']['input'];
};


export type QueryVoicemailMessageArgs = {
  userId: Scalars['Int']['input'];
  voicemailId: Scalars['Int']['input'];
};


export type QueryVoicemailsArgs = {
  userId: Scalars['Int']['input'];
};

export type RearrangeLocation = {
  __typename?: 'RearrangeLocation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pilotNumber: Scalars['String']['output'];
};

export enum RecordingStore {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type ReferenceRetarget = {
  /** The number ID of the new target. */
  newTargetNumberId: Scalars['Int']['input'];
  /** The ID of the current referrer. */
  referrerId: Scalars['Int']['input'];
};

export type ReferenceRetargetsIvr = {
  /** New reference targets for gateways. */
  gateways?: InputMaybe<Array<InputMaybe<ReferenceRetarget>>>;
  /** New reference targets for IVR acions. */
  ivrActions?: InputMaybe<Array<InputMaybe<ReferenceRetarget>>>;
  /** New reference targets for override caller references. */
  overrideCaller?: InputMaybe<Array<InputMaybe<ReferenceRetarget>>>;
};

export type ReferenceRetargetsUser = {
  /** New reference targets for gateways. */
  gateways?: InputMaybe<Array<InputMaybe<ReferenceRetarget>>>;
  /** New reference targets for IVR acions. */
  ivrActions?: InputMaybe<Array<InputMaybe<ReferenceRetarget>>>;
  /** New reference targets for override caller references. */
  overrideCaller?: InputMaybe<Array<InputMaybe<ReferenceRetarget>>>;
  /** New reference targets for phone buttons. */
  phoneButtons?: InputMaybe<Array<InputMaybe<ReferenceRetarget>>>;
  /** New reference targets for secretary references. */
  secretary?: InputMaybe<Array<InputMaybe<ReferenceRetarget>>>;
};

/** Contains entities that reference an user, fax, gateway or call group. */
export type References = {
  __typename?: 'References';
  gateways: Array<Gateway>;
  groupMemberships: Array<Group>;
  ivrActions: Array<IvrAction>;
  overrideCaller: Array<User>;
  phoneButtons: Array<BasePhoneButton>;
  secretary: Array<User>;
};

export enum ReplaceNumberOptionType {
  Extension = 'EXTENSION',
  Fax = 'FAX',
  Gateway = 'GATEWAY',
  Group = 'GROUP',
  Ivr = 'IVR'
}

export type ReplaceOption = {
  __typename?: 'ReplaceOption';
  e164: Scalars['E164']['output'];
  name: Scalars['String']['output'];
  numberId: Scalars['Int']['output'];
  numberType: NumberType;
};

export type RequestInfo = {
  __typename?: 'RequestInfo';
  /** The request ID of the current request */
  currentRequestId: Scalars['String']['output'];
  /**
   * The request IDs of the requests that are currently using database sessions.
   *         Currently this node gets a database session.
   */
  requestsUsingDatabaseSessions: Array<Scalars['String']['output']>;
};

export enum ResynchronizeError {
  CallControlCannotConnect = 'CALL_CONTROL_CANNOT_CONNECT',
  CallControlDisabled = 'CALL_CONTROL_DISABLED'
}

export type Role = {
  __typename?: 'Role';
  /** Contexts associated with the role. */
  contexts: Array<Context>;
  /** Name of the role. */
  name: Scalars['String']['output'];
  /** Permissions granted by the role. */
  permissions: Array<Scalars['String']['output']>;
};

export type SipUser = {
  __typename?: 'SIPUser';
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SaveResult = {
  __typename?: 'SaveResult';
  errors?: Maybe<Array<Error>>;
  id?: Maybe<Scalars['Int']['output']>;
};

export enum SecretaryMode {
  BossFlashing = 'BOSS_FLASHING',
  BossOnly = 'BOSS_ONLY',
  BothRinging = 'BOTH_RINGING',
  SecretaryOnly = 'SECRETARY_ONLY'
}

/** when the call is segmented in time, this describes the type of the segment */
export enum SegmentType {
  Hold = 'HOLD',
  HoldMusic = 'HOLD_MUSIC',
  Normal = 'NORMAL',
  Reroute = 'REROUTE',
  Transfer = 'TRANSFER',
  TransferByBoth = 'TRANSFER_BY_BOTH',
  TransferByCallee = 'TRANSFER_BY_CALLEE',
  TransferByCaller = 'TRANSFER_BY_CALLER'
}

export type SendReport = {
  __typename?: 'SendReport';
  fromEmail: Scalars['String']['output'];
  toEmail: Scalars['String']['output'];
};

export type ServiceDomainAllocationsInfo = {
  __typename?: 'ServiceDomainAllocationsInfo';
  ccAattendant: DomainAllocationInfo;
  ccBase: SingleItemDomainAllocationInfo;
  ccQueue: DomainAllocationInfo;
  fax: DomainAllocationInfo;
  gateway: DomainAllocationInfo;
  group5: DomainAllocationInfo;
  group10: DomainAllocationInfo;
  group20: DomainAllocationInfo;
};

export type Services = {
  __typename?: 'Services';
  callControl: Scalars['Boolean']['output'];
  fax: Scalars['Boolean']['output'];
  ldap: Scalars['Boolean']['output'];
  voicemail: Scalars['Boolean']['output'];
};

export type ServicesAllocationInput = {
  /** Number of auto attendants (ivrs) to be allocated for the domain */
  ccAattendant?: InputMaybe<Scalars['Int']['input']>;
  /** Enable Call Center related allocations in the domain */
  ccBase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of call queues to be allocated for the domain */
  ccQueue?: InputMaybe<Scalars['Int']['input']>;
  /** Number of fax services to be allocated for the domain */
  fax?: InputMaybe<Scalars['Int']['input']>;
  /** Number of call groups with 5 members to be allocated for the domain */
  group5?: InputMaybe<Scalars['Int']['input']>;
  /** Number of call groups with 10 members to be allocated for the domain */
  group10?: InputMaybe<Scalars['Int']['input']>;
  /** Number of call groups with 20 members to be allocated for the domain */
  group20?: InputMaybe<Scalars['Int']['input']>;
};

/** the type (media) of the session */
export enum SessionType {
  Audio = 'AUDIO',
  Rfb = 'RFB',
  Video = 'VIDEO'
}

export type SingleItemDomainAllocationInfo = {
  __typename?: 'SingleItemDomainAllocationInfo';
  /** Indicates if the item is allocated for the requested domain */
  domainAllocated: Scalars['Boolean']['output'];
  /** Indicates if the item is used in the requested domain. */
  domainUsed: Scalars['Boolean']['output'];
  /** System limit for this item. If null, the quota is unlimited. */
  systemLimit?: Maybe<Scalars['Int']['output']>;
  /** Allocated value of this item across all domains */
  totalAllocated: Scalars['Int']['output'];
};

export type SpecialDay = {
  __typename?: 'SpecialDay';
  considerAs: Weekday;
  day: Scalars['String']['output'];
  everyYear: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type SpecialDayList = {
  __typename?: 'SpecialDayList';
  items: Array<Maybe<SpecialDay>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SpeedDial = {
  __typename?: 'SpeedDial';
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<User>;
  extensionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  shortNumber: Scalars['String']['output'];
  targetNumber: Scalars['String']['output'];
};

export type SpeedDialInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  shortNumber: Scalars['String']['input'];
  targetNumber: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type SpeedDialList = {
  __typename?: 'SpeedDialList';
  items: Array<Maybe<SpeedDial>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StateChange = {
  __typename?: 'StateChange';
  /** the number id of the agent */
  agentNumberId: Scalars['Int']['output'];
  /** the agent state before the change */
  oldState: AgentState;
  /** the agent state after the change */
  state: AgentState;
  /** the time when the change happened */
  timeOfChange: Scalars['DateTime']['output'];
};

export type StateChangeTimeInterval = {
  /** interval length in seconds */
  length: Scalars['Int']['input'];
  /** start */
  start: Scalars['Date']['input'];
};

export type Status = {
  __typename?: 'Status';
  /** Generic information about the Concerto Web instance */
  generic: Generic;
  /** Information about the current and other requests */
  requestInfo: RequestInfo;
};

export type StructureConfig = {
  __typename?: 'StructureConfig';
  chattoUrl: Scalars['String']['output'];
  client: Client;
  features: Features;
  /** Set of languages defined in the application config */
  languages: Array<Scalars['String']['output']>;
  outgoingCallBarrings: Array<OutgoingCallBarring>;
  services: Services;
  sipProxy: Scalars['String']['output'];
  xcapUrl: Scalars['String']['output'];
};

export type SubmenuSettings = {
  /** List of buttons for the auto attendant profile */
  buttons?: InputMaybe<Array<InputMaybe<UpdateIvrButton>>>;
  /** Auto attendant can be dialed immediately */
  instantConnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of the auto attendant's menu media */
  menuMedia?: InputMaybe<Array<InputMaybe<UpdateIvrMenuMedia>>>;
  /** Path to the submenu (which buttons to press to get to the submenu) */
  path: Array<InputMaybe<Scalars['Int']['input']>>;
  /** Timeout before default action */
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type Subscription = {
  __typename?: 'Subscription';
  addressBook: Array<AddressBookEntry>;
  /** Bulk modification of an address book. This operation is done in batches. There will be an initialyield with a progress of 0, then for every batch of entries that are processed, a yield will happen with theprogress updated. When all the additions and updates are done, a yield will happen with a progress of 0.9, andwhen the deletions are also completed, the progress will be 1 */
  bulkAddressBookModification: BulkAddressBookModificationResult;
  deleteDomain: DeleteDomainStatus;
  extension: BaseUser;
  extensionProfile: UserProfile;
  groups: Array<Group>;
  ping: Scalars['String']['output'];
  /** Status of the Concerto Web instance. Updated every time a database session is created or destroyed. */
  status: Status;
  user: BaseUser;
  userProfile: UserProfile;
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionAddressBookArgs = {
  target: Scalars['String']['input'];
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionBulkAddressBookModificationArgs = {
  domainId: Scalars['Int']['input'];
  entries: Array<AddressBookEntryData>;
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionDeleteDomainArgs = {
  id: Scalars['Int']['input'];
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionExtensionArgs = {
  id: Scalars['Int']['input'];
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionExtensionProfileArgs = {
  id: Scalars['Int']['input'];
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionGroupsArgs = {
  domainId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionPingArgs = {
  pong: Scalars['String']['input'];
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionUserArgs = {
  id: Scalars['Int']['input'];
};


/** The schema’s entry-point for subscription. This acts as the public, top-level API from which all subscription queries must start. */
export type SubscriptionUserProfileArgs = {
  id: Scalars['Int']['input'];
};

export type SupervisedCallQueueInfo = {
  __typename?: 'SupervisedCallQueueInfo';
  /** The ID of the call queue */
  id: Scalars['Int']['output'];
  /** The name of the call queue */
  name: Scalars['String']['output'];
  /** The short number of the call queue */
  number: Scalars['String']['output'];
};

export type SynchronizeDomainAddressBookResult = {
  __typename?: 'SynchronizeDomainAddressBookResult';
  /** Number of created entries. */
  createdEntries?: Maybe<Scalars['Int']['output']>;
  /** Number of deleted entries. */
  deletedEntries?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Error>>;
  /** Number of failed entries. */
  failedEntries?: Maybe<Scalars['Int']['output']>;
  /** Number of updated entries. */
  updatedEntries?: Maybe<Scalars['Int']['output']>;
};

export type SynchronizeFaxResult = {
  __typename?: 'SynchronizeFaxResult';
  created?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Error>>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type SystemSettings = {
  __typename?: 'SystemSettings';
  /** The number of months excluding the current month to preserve call records for. Meaning if the value is 1, the system will preserve if the call happened in either the current month or the previous month. */
  preserveCallRecordsFor: Scalars['Int']['output'];
  /** The number of months excluding the current month to preserve call center presence changes for. Meaning if the value is 1, the system will preserve if the presence change happened in either the current month or the previous month. */
  preserveCcPresenceChangesFor: Scalars['Int']['output'];
};

export type ThirdPartyDevice = {
  __typename?: 'ThirdPartyDevice';
  clientInfo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gruu?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  registrationExpireTime?: Maybe<Scalars['DateTime']['output']>;
  registrationTime?: Maybe<Scalars['DateTime']['output']>;
  sipPassword: Scalars['String']['output'];
  sipUser: Scalars['String']['output'];
};

export type UpdateConnectionPrompt = {
  /** Name of the media */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Token for download media file. */
  downloadToken?: InputMaybe<Scalars['String']['input']>;
  /** Media file. Only not none if it is a new upload. */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** ID of the media. If set, the already uploaded media will be used with this id. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Unset the media field */
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeviceTypeSetLimit = {
  /** Device type name */
  name: Scalars['String']['input'];
  /** Device type limit */
  value: Scalars['Int']['input'];
};

export type UpdateExtensionData = {
  /** Alias (permission: edit_admin_extension, business_only: False, required_feature: alias) */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** alternate caller number id (permission: edit_admin_extension, business_only: True, required_feature: None) */
  alternateCallerNumberId?: InputMaybe<Scalars['Int']['input']>;
  /** Call limit (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  callLimit?: InputMaybe<Scalars['Int']['input']>;
  /** call origination denied (permission: edit_superuser_extension, business_only: False, required_feature: call_origination_termination_denied) */
  callOriginationDenied?: InputMaybe<Scalars['Boolean']['input']>;
  /** call termination denied (permission: edit_superuser_extension, business_only: False, required_feature: call_origination_termination_denied) */
  callTerminationDenied?: InputMaybe<Scalars['Boolean']['input']>;
  /** call waiting (permission: edit_extension, business_only: False, required_feature: None) */
  callWaiting?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cliro (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  cliro?: InputMaybe<Scalars['Boolean']['input']>;
  /** connected number presentation restriction override (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  connectedNumberPresentationRestrictionOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** direct inward dialing (permission: edit_superuser_extension, business_only: True, required_feature: None) */
  directInwardDialing?: InputMaybe<Scalars['Boolean']['input']>;
  /** direct outward dialing (permission: edit_superuser_extension, business_only: True, required_feature: None) */
  directOutwardDialing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name (permission: edit_admin_extension, business_only: False, required_feature: None) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** e164 number (permission: edit_extension, business_only: False, required_feature: None) */
  e164?: InputMaybe<Scalars['String']['input']>;
  /** feature restrictions (permission: edit_admin_extension, business_only: False, required_feature: None) */
  featureRestrictions?: InputMaybe<Array<InputMaybe<FeatureRestriction>>>;
  /** Grp memberships (permission: edit_admin_extension, business_only: True, required_feature: None) */
  groupMembershipGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** home number (permission: edit_extension, business_only: True, required_feature: None) */
  homeNumber?: InputMaybe<Scalars['String']['input']>;
  /** hot number (permission: edit_extension, business_only: False, required_feature: hot_number) */
  hotNumber?: InputMaybe<Scalars['String']['input']>;
  /** international cac (permission: edit_superuser_extension, business_only: False, required_feature: enable_carrier_access_codes) */
  internationalCac?: InputMaybe<Scalars['String']['input']>;
  /** location id (permission: add_extension, business_only: False, required_feature: None) */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** malicious call trace (permission: edit_superuser_extension, business_only: False, required_feature: malicious_call_trace) */
  maliciousCallTrace?: InputMaybe<Scalars['Boolean']['input']>;
  /** mobile number (permission: edit_extension, business_only: False, required_feature: None) */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /** national cac (permission: edit_superuser_extension, business_only: False, required_feature: enable_carrier_access_codes) */
  nationalCac?: InputMaybe<Scalars['String']['input']>;
  /** non payment blocking type (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  nonPaymentBlockingType?: InputMaybe<NonPaymentBlockingType>;
  /** notification email (permission: edit_extension, business_only: False, required_feature: None) */
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  /** outgoing call barring admin (permission: edit_admin_extension, business_only: False, required_feature: None) */
  outgoingCallBarringAdmin?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  /** outgoing call barring operator (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  outgoingCallBarringOperator?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  /** outgoing call barring user (permission: edit_extension, business_only: False, required_feature: None) */
  outgoingCallBarringUser?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  /** Pin (permission: edit_extension, business_only: False, required_feature: None) */
  pin?: InputMaybe<Scalars['String']['input']>;
  /** preview features enabled (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  previewFeaturesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** private routing type (permission: edit_superuser_extension, business_only: True, required_feature: None) */
  privateRoutingType?: InputMaybe<PrivateRoutingType>;
  /** secretary number id (permission: edit_admin_extension, business_only: True, required_feature: None) */
  secretaryNumberId?: InputMaybe<Scalars['Int']['input']>;
  /** voicemail to email enabled (permission: edit_extension, business_only: False, required_feature: None) */
  voicemailToEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGatewayData = {
  callbackNumberId?: InputMaybe<Scalars['Int']['input']>;
  callbackType?: InputMaybe<CallbackType>;
  /** Name of the gateway. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Gateway is enabled or not. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  multipleCallsNumber?: InputMaybe<Scalars['Int']['input']>;
  nonPaymentBlockingType?: InputMaybe<NonPaymentBlockingType>;
  outgoingCallBarringOperator?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  sipPassword?: InputMaybe<Scalars['String']['input']>;
  sipUser?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIvrAnnouncement = {
  /** Name of the media */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Token for download media file. */
  downloadToken?: InputMaybe<Scalars['String']['input']>;
  /** Media file. Only not none if it is a new upload. */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** ID of the media. If set, the already uploaded media will be used with this id. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Unset the media field */
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIvrButton = {
  /** Switch to, Switch to IVR, Switch to submenu etc. */
  actionType?: InputMaybe<IvrActionType>;
  /** The connections prompt for an action */
  connectionPrompt?: InputMaybe<UpdateConnectionPrompt>;
  /** Contains the target number E164, if the target is external */
  targetE164?: InputMaybe<Scalars['String']['input']>;
  /** Contains the target number ID, if the target is an ivr or user */
  targetNumberId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateIvrMenuMedia = {
  /** Name of the media */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Media is disabled or not */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Token for download media file. */
  downloadToken?: InputMaybe<Scalars['String']['input']>;
  /** Media file. Only not none if it is a new upload. */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** ID of the media. If set, the already uploaded media will be used with this id. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserData = {
  /** Alias (permission: edit_admin_extension, business_only: False, required_feature: alias) */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** alternate caller number id (permission: edit_admin_extension, business_only: True, required_feature: None) */
  alternateCallerNumberId?: InputMaybe<Scalars['Int']['input']>;
  /** Call limit (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  callLimit?: InputMaybe<Scalars['Int']['input']>;
  /** call origination denied (permission: edit_superuser_extension, business_only: False, required_feature: call_origination_termination_denied) */
  callOriginationDenied?: InputMaybe<Scalars['Boolean']['input']>;
  /** call termination denied (permission: edit_superuser_extension, business_only: False, required_feature: call_origination_termination_denied) */
  callTerminationDenied?: InputMaybe<Scalars['Boolean']['input']>;
  /** call waiting (permission: edit_extension, business_only: False, required_feature: None) */
  callWaiting?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cliro (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  cliro?: InputMaybe<Scalars['Boolean']['input']>;
  /** connected number presentation restriction override (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  connectedNumberPresentationRestrictionOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** direct inward dialing (permission: edit_superuser_extension, business_only: True, required_feature: None) */
  directInwardDialing?: InputMaybe<Scalars['Boolean']['input']>;
  /** direct outward dialing (permission: edit_superuser_extension, business_only: True, required_feature: None) */
  directOutwardDialing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name (permission: edit_admin_extension, business_only: False, required_feature: None) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** e164 number (permission: edit_extension, business_only: False, required_feature: None) */
  e164?: InputMaybe<Scalars['String']['input']>;
  /** feature restrictions (permission: edit_admin_extension, business_only: False, required_feature: None) */
  featureRestrictions?: InputMaybe<Array<InputMaybe<FeatureRestriction>>>;
  /** Grp memberships (permission: edit_admin_extension, business_only: True, required_feature: None) */
  groupMembershipGroupIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** home number (permission: edit_extension, business_only: True, required_feature: None) */
  homeNumber?: InputMaybe<Scalars['String']['input']>;
  /** hot number (permission: edit_extension, business_only: False, required_feature: hot_number) */
  hotNumber?: InputMaybe<Scalars['String']['input']>;
  /** international cac (permission: edit_superuser_extension, business_only: False, required_feature: enable_carrier_access_codes) */
  internationalCac?: InputMaybe<Scalars['String']['input']>;
  /** location id (permission: add_extension, business_only: False, required_feature: None) */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** malicious call trace (permission: edit_superuser_extension, business_only: False, required_feature: malicious_call_trace) */
  maliciousCallTrace?: InputMaybe<Scalars['Boolean']['input']>;
  /** mobile number (permission: edit_extension, business_only: False, required_feature: None) */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /** national cac (permission: edit_superuser_extension, business_only: False, required_feature: enable_carrier_access_codes) */
  nationalCac?: InputMaybe<Scalars['String']['input']>;
  /** non payment blocking type (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  nonPaymentBlockingType?: InputMaybe<NonPaymentBlockingType>;
  /** notification email (permission: edit_extension, business_only: False, required_feature: None) */
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  /** outgoing call barring admin (permission: edit_admin_extension, business_only: False, required_feature: None) */
  outgoingCallBarringAdmin?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  /** outgoing call barring operator (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  outgoingCallBarringOperator?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  /** outgoing call barring user (permission: edit_extension, business_only: False, required_feature: None) */
  outgoingCallBarringUser?: InputMaybe<Array<InputMaybe<OutgoingCallBarring>>>;
  /** Pin (permission: edit_extension, business_only: False, required_feature: None) */
  pin?: InputMaybe<Scalars['String']['input']>;
  /** preview features enabled (permission: edit_superuser_extension, business_only: False, required_feature: None) */
  previewFeaturesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** private routing type (permission: edit_superuser_extension, business_only: True, required_feature: None) */
  privateRoutingType?: InputMaybe<PrivateRoutingType>;
  /** secretary number id (permission: edit_admin_extension, business_only: True, required_feature: None) */
  secretaryNumberId?: InputMaybe<Scalars['Int']['input']>;
  /** voicemail to email enabled (permission: edit_extension, business_only: False, required_feature: None) */
  voicemailToEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserProfileData = {
  /** anonymous call rejection (business_only: False, restriction: FeatureRestriction.CALL_REJECTIONS) */
  anonymousCallRejection?: InputMaybe<Scalars['Boolean']['input']>;
  /** call forward busy (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardBusy?: InputMaybe<Scalars['Boolean']['input']>;
  /** call forward busy number (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardBusyNumber?: InputMaybe<Scalars['String']['input']>;
  /** call forward fault (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardFault?: InputMaybe<Scalars['Boolean']['input']>;
  /** call forward fault number (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardFaultNumber?: InputMaybe<Scalars['String']['input']>;
  /** call forward noanswer (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardNoanswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** call forward noanswer number (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardNoanswerNumber?: InputMaybe<Scalars['String']['input']>;
  /** call forward noanswer timeout (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardNoanswerTimeout?: InputMaybe<Scalars['Int']['input']>;
  /** call forward noanswer (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardNoanswer_?: InputMaybe<Scalars['Boolean']['input']>;
  /** call forward unavailable (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** call forward unavailable number (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardUnavailableNumber?: InputMaybe<Scalars['String']['input']>;
  /** call forward unconditional (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardUnconditional?: InputMaybe<Scalars['Boolean']['input']>;
  /** call forward unconditional number (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  callForwardUnconditionalNumber?: InputMaybe<Scalars['String']['input']>;
  /** calling name presentation (business_only: False, restriction: None) */
  callingNamePresentation?: InputMaybe<Scalars['Boolean']['input']>;
  /** calling number presentation restriction (business_only: False, restriction: FeatureRestriction.NUMBER_PRESENTATION) */
  callingNumberPresentationRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  /** connected number presentation restriction (business_only: False, restriction: FeatureRestriction.NUMBER_PRESENTATION) */
  connectedNumberPresentationRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  /** do not disturb (business_only: False, restriction: FeatureRestriction.CALL_REJECTIONS) */
  doNotDisturb?: InputMaybe<Scalars['Boolean']['input']>;
  /** Locked (business_only: False, restriction: FeatureRestriction.LOCKING) */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name (business_only: False, restriction: None) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** parallel ringing (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  parallelRinging?: InputMaybe<Scalars['Boolean']['input']>;
  /** parallel ringing number (business_only: False, restriction: FeatureRestriction.CALL_ROUTINGS) */
  parallelRingingNumber?: InputMaybe<Scalars['String']['input']>;
  /** reject diverted calls (business_only: False, restriction: FeatureRestriction.CALL_REJECTIONS) */
  rejectDivertedCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** secretary mode (business_only: False, restriction: None) */
  secretaryMode?: InputMaybe<SecretaryMode>;
  /** Activation times settings (business_only: False, restriction: None) */
  settings?: InputMaybe<UserActivationSettings>;
  /** sticky profile (business_only: False, restriction: None) */
  stickyProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserResult = {
  __typename?: 'UpdateUserResult';
  devicesToResync?: Maybe<Array<Scalars['Int']['output']>>;
  errors?: Maybe<Array<Error>>;
};

export type User = {
  __typename?: 'User';
  alias?: Maybe<Scalars['String']['output']>;
  alternateCallerNumber?: Maybe<Number>;
  alternateCallerNumberId?: Maybe<Scalars['Int']['output']>;
  callLimit: Scalars['Int']['output'];
  callPark: Scalars['Boolean']['output'];
  callWaiting: Scalars['Boolean']['output'];
  cliro: Scalars['Boolean']['output'];
  connectedNumberPresentationRestrictionOverride: Scalars['Boolean']['output'];
  directInwardDialing: Scalars['Boolean']['output'];
  directOutwardDialing: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  featuresRestrictions: Array<Maybe<FeatureRestriction>>;
  homeNumber: Scalars['String']['output'];
  hotnumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internationalCac: Scalars['String']['output'];
  lastCallId?: Maybe<Scalars['String']['output']>;
  lastCallReturn?: Maybe<Scalars['String']['output']>;
  ldapPassword?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId: Scalars['Int']['output'];
  maliciousCallTrace: Scalars['Boolean']['output'];
  mobileNumber: Scalars['String']['output'];
  monthlyLimit?: Maybe<Scalars['Float']['output']>;
  nationalCac: Scalars['String']['output'];
  needWebPasswordChange: Scalars['Boolean']['output'];
  notificationEmail?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Number>;
  numberId: Scalars['Int']['output'];
  outgoingCallBarringAdmin?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringOperator?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  outgoingCallBarringUser?: Maybe<Scalars['OutgoingCallBarringType']['output']>;
  pin: Scalars['String']['output'];
  previewFeaturesEnabled: Scalars['Boolean']['output'];
  privateRoutingType: PrivateRoutingType;
  profiles: Array<UserProfile>;
  recordingFileSize: Scalars['Int']['output'];
  recordingType: DirectionType;
  redirectToSecretary: Scalars['Boolean']['output'];
  secretaryNumber?: Maybe<Number>;
  secretaryNumberId?: Maybe<Scalars['Int']['output']>;
  sendAccounting?: Maybe<Scalars['Boolean']['output']>;
  speeddial8: Scalars['Boolean']['output'];
  speeddial100: Scalars['Boolean']['output'];
  useOcs?: Maybe<Scalars['Boolean']['output']>;
  userPackageName?: Maybe<Scalars['String']['output']>;
  userSub?: Maybe<Scalars['String']['output']>;
  voicemailToEmailEnabled: Scalars['Boolean']['output'];
  xcapPassword: Scalars['String']['output'];
};

export type UserActivationSettings = {
  /** Activation values for the profile (business_only: False, restriction: None) */
  activationTimes?: InputMaybe<Array<InputMaybe<ActivationTime>>>;
  /** List of specific activation times for the profile (business_only: False, restriction: None) */
  specialDays?: InputMaybe<Array<InputMaybe<ProfileSpecialDay>>>;
};

export type UserBasicInfo = {
  __typename?: 'UserBasicInfo';
  devicesClient?: Maybe<Scalars['Int']['output']>;
  devicesClientNotRegistered?: Maybe<Scalars['Int']['output']>;
  devicesLinked?: Maybe<Scalars['Int']['output']>;
  devicesLinkedNotRegistered?: Maybe<Scalars['Int']['output']>;
  devicesProvisioned?: Maybe<Scalars['Int']['output']>;
  devicesProvisionedNotRegistered?: Maybe<Scalars['Int']['output']>;
  devicesThirdparty?: Maybe<Scalars['Int']['output']>;
  devicesThirdpartyNotRegistered?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  e164?: Maybe<Scalars['String']['output']>;
  shortNumber?: Maybe<Scalars['String']['output']>;
};

export type UserCapabilities = {
  __typename?: 'UserCapabilities';
  capabilities?: Maybe<Array<Maybe<Capability>>>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type UserDeviceTypeSetQuota = {
  __typename?: 'UserDeviceTypeSetQuota';
  name: Scalars['String']['output'];
  used: Scalars['Int']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type UserList = {
  __typename?: 'UserList';
  items: Array<Maybe<User>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserLogin = {
  __typename?: 'UserLogin';
  emails: Array<Scalars['String']['output']>;
  isVerified: Scalars['Boolean']['output'];
  loginNames: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  userSub: Scalars['String']['output'];
};

export type UserOwner = {
  __typename?: 'UserOwner';
  userSub?: Maybe<Scalars['String']['output']>;
};

/**
 * Device type set class without the used property.
 *
 * Used for information purposes on frontend.
 */
export type UserPackageDeviceTypeSet = {
  __typename?: 'UserPackageDeviceTypeSet';
  /** Name of the device type set */
  name: Scalars['String']['output'];
  /** Number of devices of this type that the user package gives */
  quantity: Scalars['Int']['output'];
};

/** Information about a package got from the limit file. */
export type UserPackageInfo = {
  __typename?: 'UserPackageInfo';
  /** Capability sets that are given by the package */
  capabilitySets: Array<Scalars['String']['output']>;
  /** Device type sets that are given by the package */
  deviceTypeSets: Array<UserPackageDeviceTypeSet>;
  /** Name of the package */
  name: Scalars['String']['output'];
  /** Maximum number of packages allowed for allocation */
  quota: Scalars['Int']['output'];
  /** Type of the package */
  type: Scalars['String']['output'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  activationTimes: Array<UserProfileActivationTime>;
  active: Scalars['Boolean']['output'];
  anonymousCallRejection: Scalars['Boolean']['output'];
  callForwardBusy: Scalars['Boolean']['output'];
  callForwardBusyNumber: Scalars['String']['output'];
  callForwardBusySavedNumber: Scalars['String']['output'];
  callForwardFault: Scalars['Boolean']['output'];
  callForwardFaultNumber: Scalars['String']['output'];
  callForwardFaultSavedNumber: Scalars['String']['output'];
  callForwardNoanswer: Scalars['Boolean']['output'];
  callForwardNoanswerNumber: Scalars['String']['output'];
  callForwardNoanswerSavedNumber: Scalars['String']['output'];
  callForwardNoanswerTimeout: Scalars['Int']['output'];
  callForwardUnavailable: Scalars['Boolean']['output'];
  callForwardUnavailableNumber: Scalars['String']['output'];
  callForwardUnavailableSavedNumber: Scalars['String']['output'];
  callForwardUnconditional: Scalars['Boolean']['output'];
  callForwardUnconditionalNumber: Scalars['String']['output'];
  callForwardUnconditionalSavedNumber: Scalars['String']['output'];
  callingNamePresentation: Scalars['Boolean']['output'];
  callingNumberPresentationRestriction: Scalars['Boolean']['output'];
  connectedNumberPresentationRestriction: Scalars['Boolean']['output'];
  doNotDisturb: Scalars['Boolean']['output'];
  extension?: Maybe<User>;
  extensionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  parallelRinging: Scalars['Boolean']['output'];
  parallelRingingNumber: Scalars['String']['output'];
  parallelRingingSavedNumber: Scalars['String']['output'];
  rejectDivertedCalls: Scalars['Boolean']['output'];
  rules: Array<UserProfileRule>;
  secretaryMode: SecretaryMode;
  specialDays: Array<UserProfileSpecialDay>;
  stickyProfile: Scalars['Boolean']['output'];
};

export type UserProfileActivationTime = {
  __typename?: 'UserProfileActivationTime';
  activationTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  weekday: Weekday;
};

export type UserProfileDnd = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export type UserProfileRule = {
  __typename?: 'UserProfileRule';
  action: ExtensionProfileRuleAction;
  extProfile?: Maybe<UserProfile>;
  extProfileId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  matchType?: Maybe<UserProfileRuleMatchType>;
  priority: Scalars['Int']['output'];
  sourceNumber: Scalars['String']['output'];
  targetNumber: Scalars['String']['output'];
};

export type UserProfileRuleData = {
  action?: InputMaybe<ExtensionProfileRuleAction>;
  matchType?: InputMaybe<UserProfileRuleMatchType>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  sourceNumber?: InputMaybe<Scalars['String']['input']>;
  targetNumber?: InputMaybe<Scalars['String']['input']>;
  userProfileId?: InputMaybe<Scalars['Int']['input']>;
};

export enum UserProfileRuleMatchType {
  Contains = 'contains',
  EndsWith = 'ends_with',
  Identical = 'identical',
  StartsWith = 'starts_with'
}

export type UserProfileSpecialDay = {
  __typename?: 'UserProfileSpecialDay';
  activationTime?: Maybe<Scalars['String']['output']>;
  day: Scalars['String']['output'];
  everyYear: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
};

export type UserProfiles = {
  __typename?: 'UserProfiles';
  error?: Maybe<Error>;
  profiles?: Maybe<Array<Scalars['Int']['output']>>;
};

export type UserQuotaInfo = {
  __typename?: 'UserQuotaInfo';
  capabilitySets: Array<Scalars['String']['output']>;
  deviceTypeSets: Array<UserDeviceTypeSetQuota>;
};

export type UserStatus = {
  __typename?: 'UserStatus';
  clientInfo?: Maybe<Scalars['String']['output']>;
  deviceDescription?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceType>;
  e164?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  linkedE164?: Maybe<Scalars['String']['output']>;
  linkedShortNumber?: Maybe<Scalars['String']['output']>;
  linkedUserId?: Maybe<Scalars['Int']['output']>;
  registrationExpireTime?: Maybe<Scalars['DateTime']['output']>;
  registrationTime?: Maybe<Scalars['DateTime']['output']>;
  shortNumber?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type Vendor = {
  __typename?: 'Vendor';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Voicemail entry object */
export type VoicemailEntry = {
  __typename?: 'VoicemailEntry';
  /** Call ID of the voicemail entry */
  callId: Scalars['String']['output'];
  /** Whether the voicemail entry has been listened to */
  listened: Scalars['Boolean']['output'];
  /** Voicemail ID of the voicemail entry */
  voicemailId: Scalars['Int']['output'];
};

/** Voicemail list object */
export type VoicemailList = {
  __typename?: 'VoicemailList';
  errors?: Maybe<Array<Error>>;
  /** List of voicemail entries for the user */
  voicemails?: Maybe<Array<VoicemailEntry>>;
};

export enum Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}
